import ke, { useState as jn, useMemo as Dr, useEffect as In, useContext as St, useRef as Dn, useLayoutEffect as go, createElement as yo, useCallback as vo } from "react";
var bo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ur(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Ln(r) {
  if (r.__esModule)
    return r;
  var o = r.default;
  if (typeof o == "function") {
    var t = function a() {
      return this instanceof a ? Reflect.construct(o, arguments, this.constructor) : o.apply(this, arguments);
    };
    t.prototype = o.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(a) {
    var i = Object.getOwnPropertyDescriptor(r, a);
    Object.defineProperty(t, a, i.get ? i : {
      enumerable: !0,
      get: function() {
        return r[a];
      }
    });
  }), t;
}
var Lr = { exports: {} }, It = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cn;
function So() {
  if (cn)
    return It;
  cn = 1;
  var r = ke, o = Symbol.for("react.element"), t = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, f = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(d, p, y) {
    var S, w = {}, x = null, _ = null;
    y !== void 0 && (x = "" + y), p.key !== void 0 && (x = "" + p.key), p.ref !== void 0 && (_ = p.ref);
    for (S in p)
      a.call(p, S) && !f.hasOwnProperty(S) && (w[S] = p[S]);
    if (d && d.defaultProps)
      for (S in p = d.defaultProps, p)
        w[S] === void 0 && (w[S] = p[S]);
    return { $$typeof: o, type: d, key: x, ref: _, props: w, _owner: i.current };
  }
  return It.Fragment = t, It.jsx = c, It.jsxs = c, It;
}
var Dt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ln;
function wo() {
  return ln || (ln = 1, process.env.NODE_ENV !== "production" && function() {
    var r = ke, o = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), d = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), S = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), O = Symbol.iterator, I = "@@iterator";
    function j(u) {
      if (u === null || typeof u != "object")
        return null;
      var C = O && u[O] || u[I];
      return typeof C == "function" ? C : null;
    }
    var D = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(u) {
      {
        for (var C = arguments.length, N = new Array(C > 1 ? C - 1 : 0), H = 1; H < C; H++)
          N[H - 1] = arguments[H];
        L("error", u, N);
      }
    }
    function L(u, C, N) {
      {
        var H = D.ReactDebugCurrentFrame, ce = H.getStackAddendum();
        ce !== "" && (C += "%s", N = N.concat([ce]));
        var me = N.map(function(re) {
          return String(re);
        });
        me.unshift("Warning: " + C), Function.prototype.apply.call(console[u], console, me);
      }
    }
    var $ = !1, E = !1, z = !1, oe = !1, Ee = !1, ue;
    ue = Symbol.for("react.module.reference");
    function Oe(u) {
      return !!(typeof u == "string" || typeof u == "function" || u === a || u === f || Ee || u === i || u === y || u === S || oe || u === _ || $ || E || z || typeof u == "object" && u !== null && (u.$$typeof === x || u.$$typeof === w || u.$$typeof === c || u.$$typeof === d || u.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      u.$$typeof === ue || u.getModuleId !== void 0));
    }
    function Ae(u, C, N) {
      var H = u.displayName;
      if (H)
        return H;
      var ce = C.displayName || C.name || "";
      return ce !== "" ? N + "(" + ce + ")" : N;
    }
    function K(u) {
      return u.displayName || "Context";
    }
    function J(u) {
      if (u == null)
        return null;
      if (typeof u.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof u == "function")
        return u.displayName || u.name || null;
      if (typeof u == "string")
        return u;
      switch (u) {
        case a:
          return "Fragment";
        case t:
          return "Portal";
        case f:
          return "Profiler";
        case i:
          return "StrictMode";
        case y:
          return "Suspense";
        case S:
          return "SuspenseList";
      }
      if (typeof u == "object")
        switch (u.$$typeof) {
          case d:
            var C = u;
            return K(C) + ".Consumer";
          case c:
            var N = u;
            return K(N._context) + ".Provider";
          case p:
            return Ae(u, u.render, "ForwardRef");
          case w:
            var H = u.displayName || null;
            return H !== null ? H : J(u.type) || "Memo";
          case x: {
            var ce = u, me = ce._payload, re = ce._init;
            try {
              return J(re(me));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, ye = 0, Ie, he, ve, Ve, Le, Ye, M;
    function F() {
    }
    F.__reactDisabledLog = !0;
    function B() {
      {
        if (ye === 0) {
          Ie = console.log, he = console.info, ve = console.warn, Ve = console.error, Le = console.group, Ye = console.groupCollapsed, M = console.groupEnd;
          var u = {
            configurable: !0,
            enumerable: !0,
            value: F,
            writable: !0
          };
          Object.defineProperties(console, {
            info: u,
            log: u,
            warn: u,
            error: u,
            group: u,
            groupCollapsed: u,
            groupEnd: u
          });
        }
        ye++;
      }
    }
    function V() {
      {
        if (ye--, ye === 0) {
          var u = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, u, {
              value: Ie
            }),
            info: Z({}, u, {
              value: he
            }),
            warn: Z({}, u, {
              value: ve
            }),
            error: Z({}, u, {
              value: Ve
            }),
            group: Z({}, u, {
              value: Le
            }),
            groupCollapsed: Z({}, u, {
              value: Ye
            }),
            groupEnd: Z({}, u, {
              value: M
            })
          });
        }
        ye < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var m = D.ReactCurrentDispatcher, ee;
    function T(u, C, N) {
      {
        if (ee === void 0)
          try {
            throw Error();
          } catch (ce) {
            var H = ce.stack.trim().match(/\n( *(at )?)/);
            ee = H && H[1] || "";
          }
        return `
` + ee + u;
      }
    }
    var de = !1, te;
    {
      var ae = typeof WeakMap == "function" ? WeakMap : Map;
      te = new ae();
    }
    function R(u, C) {
      if (!u || de)
        return "";
      {
        var N = te.get(u);
        if (N !== void 0)
          return N;
      }
      var H;
      de = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var me;
      me = m.current, m.current = null, B();
      try {
        if (C) {
          var re = function() {
            throw Error();
          };
          if (Object.defineProperty(re.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(re, []);
            } catch (Ze) {
              H = Ze;
            }
            Reflect.construct(u, [], re);
          } else {
            try {
              re.call();
            } catch (Ze) {
              H = Ze;
            }
            u.call(re.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ze) {
            H = Ze;
          }
          u();
        }
      } catch (Ze) {
        if (Ze && H && typeof Ze.stack == "string") {
          for (var q = Ze.stack.split(`
`), _e = H.stack.split(`
`), xe = q.length - 1, Se = _e.length - 1; xe >= 1 && Se >= 0 && q[xe] !== _e[Se]; )
            Se--;
          for (; xe >= 1 && Se >= 0; xe--, Se--)
            if (q[xe] !== _e[Se]) {
              if (xe !== 1 || Se !== 1)
                do
                  if (xe--, Se--, Se < 0 || q[xe] !== _e[Se]) {
                    var $e = `
` + q[xe].replace(" at new ", " at ");
                    return u.displayName && $e.includes("<anonymous>") && ($e = $e.replace("<anonymous>", u.displayName)), typeof u == "function" && te.set(u, $e), $e;
                  }
                while (xe >= 1 && Se >= 0);
              break;
            }
        }
      } finally {
        de = !1, m.current = me, V(), Error.prepareStackTrace = ce;
      }
      var ct = u ? u.displayName || u.name : "", Jt = ct ? T(ct) : "";
      return typeof u == "function" && te.set(u, Jt), Jt;
    }
    function be(u, C, N) {
      return R(u, !1);
    }
    function Re(u) {
      var C = u.prototype;
      return !!(C && C.isReactComponent);
    }
    function X(u, C, N) {
      if (u == null)
        return "";
      if (typeof u == "function")
        return R(u, Re(u));
      if (typeof u == "string")
        return T(u);
      switch (u) {
        case y:
          return T("Suspense");
        case S:
          return T("SuspenseList");
      }
      if (typeof u == "object")
        switch (u.$$typeof) {
          case p:
            return be(u.render);
          case w:
            return X(u.type, C, N);
          case x: {
            var H = u, ce = H._payload, me = H._init;
            try {
              return X(me(ce), C, N);
            } catch {
            }
          }
        }
      return "";
    }
    var Ce = Object.prototype.hasOwnProperty, ie = {}, Te = D.ReactDebugCurrentFrame;
    function Ke(u) {
      if (u) {
        var C = u._owner, N = X(u.type, u._source, C ? C.type : null);
        Te.setExtraStackFrame(N);
      } else
        Te.setExtraStackFrame(null);
    }
    function v(u, C, N, H, ce) {
      {
        var me = Function.call.bind(Ce);
        for (var re in u)
          if (me(u, re)) {
            var q = void 0;
            try {
              if (typeof u[re] != "function") {
                var _e = Error((H || "React class") + ": " + N + " type `" + re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _e.name = "Invariant Violation", _e;
              }
              q = u[re](C, re, H, N, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (xe) {
              q = xe;
            }
            q && !(q instanceof Error) && (Ke(ce), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", H || "React class", N, re, typeof q), Ke(null)), q instanceof Error && !(q.message in ie) && (ie[q.message] = !0, Ke(ce), k("Failed %s type: %s", N, q.message), Ke(null));
          }
      }
    }
    var Q = Array.isArray;
    function qe(u) {
      return Q(u);
    }
    function De(u) {
      {
        var C = typeof Symbol == "function" && Symbol.toStringTag, N = C && u[Symbol.toStringTag] || u.constructor.name || "Object";
        return N;
      }
    }
    function Y(u) {
      try {
        return ge(u), !1;
      } catch {
        return !0;
      }
    }
    function ge(u) {
      return "" + u;
    }
    function nt(u) {
      if (Y(u))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", De(u)), ge(u);
    }
    var Ge = D.ReactCurrentOwner, Xe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, zt, mt, wt;
    wt = {};
    function _t(u) {
      if (Ce.call(u, "ref")) {
        var C = Object.getOwnPropertyDescriptor(u, "ref").get;
        if (C && C.isReactWarning)
          return !1;
      }
      return u.ref !== void 0;
    }
    function Ut(u) {
      if (Ce.call(u, "key")) {
        var C = Object.getOwnPropertyDescriptor(u, "key").get;
        if (C && C.isReactWarning)
          return !1;
      }
      return u.key !== void 0;
    }
    function gr(u, C) {
      if (typeof u.ref == "string" && Ge.current && C && Ge.current.stateNode !== C) {
        var N = J(Ge.current.type);
        wt[N] || (k('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', J(Ge.current.type), u.ref), wt[N] = !0);
      }
    }
    function Wt(u, C) {
      {
        var N = function() {
          zt || (zt = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        N.isReactWarning = !0, Object.defineProperty(u, "key", {
          get: N,
          configurable: !0
        });
      }
    }
    function yr(u, C) {
      {
        var N = function() {
          mt || (mt = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        N.isReactWarning = !0, Object.defineProperty(u, "ref", {
          get: N,
          configurable: !0
        });
      }
    }
    var Ht = function(u, C, N, H, ce, me, re) {
      var q = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: o,
        // Built-in properties that belong on the element
        type: u,
        key: C,
        ref: N,
        props: re,
        // Record the component responsible for creating this element.
        _owner: me
      };
      return q._store = {}, Object.defineProperty(q._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(q, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: H
      }), Object.defineProperty(q, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(q.props), Object.freeze(q)), q;
    };
    function Vt(u, C, N, H, ce) {
      {
        var me, re = {}, q = null, _e = null;
        N !== void 0 && (nt(N), q = "" + N), Ut(C) && (nt(C.key), q = "" + C.key), _t(C) && (_e = C.ref, gr(C, ce));
        for (me in C)
          Ce.call(C, me) && !Xe.hasOwnProperty(me) && (re[me] = C[me]);
        if (u && u.defaultProps) {
          var xe = u.defaultProps;
          for (me in xe)
            re[me] === void 0 && (re[me] = xe[me]);
        }
        if (q || _e) {
          var Se = typeof u == "function" ? u.displayName || u.name || "Unknown" : u;
          q && Wt(re, Se), _e && yr(re, Se);
        }
        return Ht(u, q, _e, ce, H, Ge.current, re);
      }
    }
    var Pt = D.ReactCurrentOwner, Yt = D.ReactDebugCurrentFrame;
    function st(u) {
      if (u) {
        var C = u._owner, N = X(u.type, u._source, C ? C.type : null);
        Yt.setExtraStackFrame(N);
      } else
        Yt.setExtraStackFrame(null);
    }
    var kt;
    kt = !1;
    function Nt(u) {
      return typeof u == "object" && u !== null && u.$$typeof === o;
    }
    function Me() {
      {
        if (Pt.current) {
          var u = J(Pt.current.type);
          if (u)
            return `

Check the render method of \`` + u + "`.";
        }
        return "";
      }
    }
    function vr(u) {
      {
        if (u !== void 0) {
          var C = u.fileName.replace(/^.*[\\\/]/, ""), N = u.lineNumber;
          return `

Check your code at ` + C + ":" + N + ".";
        }
        return "";
      }
    }
    var qt = {};
    function br(u) {
      {
        var C = Me();
        if (!C) {
          var N = typeof u == "string" ? u : u.displayName || u.name;
          N && (C = `

Check the top-level render call using <` + N + ">.");
        }
        return C;
      }
    }
    function jt(u, C) {
      {
        if (!u._store || u._store.validated || u.key != null)
          return;
        u._store.validated = !0;
        var N = br(C);
        if (qt[N])
          return;
        qt[N] = !0;
        var H = "";
        u && u._owner && u._owner !== Pt.current && (H = " It was passed a child from " + J(u._owner.type) + "."), st(u), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', N, H), st(null);
      }
    }
    function Gt(u, C) {
      {
        if (typeof u != "object")
          return;
        if (qe(u))
          for (var N = 0; N < u.length; N++) {
            var H = u[N];
            Nt(H) && jt(H, C);
          }
        else if (Nt(u))
          u._store && (u._store.validated = !0);
        else if (u) {
          var ce = j(u);
          if (typeof ce == "function" && ce !== u.entries)
            for (var me = ce.call(u), re; !(re = me.next()).done; )
              Nt(re.value) && jt(re.value, C);
        }
      }
    }
    function Sr(u) {
      {
        var C = u.type;
        if (C == null || typeof C == "string")
          return;
        var N;
        if (typeof C == "function")
          N = C.propTypes;
        else if (typeof C == "object" && (C.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        C.$$typeof === w))
          N = C.propTypes;
        else
          return;
        if (N) {
          var H = J(C);
          v(N, u.props, "prop", H, u);
        } else if (C.PropTypes !== void 0 && !kt) {
          kt = !0;
          var ce = J(C);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof C.getDefaultProps == "function" && !C.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Et(u) {
      {
        for (var C = Object.keys(u.props), N = 0; N < C.length; N++) {
          var H = C[N];
          if (H !== "children" && H !== "key") {
            st(u), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", H), st(null);
            break;
          }
        }
        u.ref !== null && (st(u), k("Invalid attribute `ref` supplied to `React.Fragment`."), st(null));
      }
    }
    function Rt(u, C, N, H, ce, me) {
      {
        var re = Oe(u);
        if (!re) {
          var q = "";
          (u === void 0 || typeof u == "object" && u !== null && Object.keys(u).length === 0) && (q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _e = vr(ce);
          _e ? q += _e : q += Me();
          var xe;
          u === null ? xe = "null" : qe(u) ? xe = "array" : u !== void 0 && u.$$typeof === o ? (xe = "<" + (J(u.type) || "Unknown") + " />", q = " Did you accidentally export a JSX literal instead of a component?") : xe = typeof u, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", xe, q);
        }
        var Se = Vt(u, C, N, ce, me);
        if (Se == null)
          return Se;
        if (re) {
          var $e = C.children;
          if ($e !== void 0)
            if (H)
              if (qe($e)) {
                for (var ct = 0; ct < $e.length; ct++)
                  Gt($e[ct], u);
                Object.freeze && Object.freeze($e);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Gt($e, u);
        }
        return u === a ? Et(Se) : Sr(Se), Se;
      }
    }
    function wr(u, C, N) {
      return Rt(u, C, N, !0);
    }
    function Er(u, C, N) {
      return Rt(u, C, N, !1);
    }
    var Xt = Er, gt = wr;
    Dt.Fragment = a, Dt.jsx = Xt, Dt.jsxs = gt;
  }()), Dt;
}
process.env.NODE_ENV === "production" ? Lr.exports = So() : Lr.exports = wo();
var ut = Lr.exports;
const Eo = () => {
  const { hostname: r } = window.location;
  return r === "localhost";
}, Ro = () => {
  const { hostname: r } = window.location;
  return /^(www-t|www-ts)\./.test(r);
}, xo = () => /* @__PURE__ */ ut.jsx("div", { className: "environment-info-banner environment-info-development-banner", children: "DEVELOPMENT" });
var $n = { exports: {} }, $r = { exports: {} }, fe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var un;
function Oo() {
  if (un)
    return fe;
  un = 1;
  var r = typeof Symbol == "function" && Symbol.for, o = r ? Symbol.for("react.element") : 60103, t = r ? Symbol.for("react.portal") : 60106, a = r ? Symbol.for("react.fragment") : 60107, i = r ? Symbol.for("react.strict_mode") : 60108, f = r ? Symbol.for("react.profiler") : 60114, c = r ? Symbol.for("react.provider") : 60109, d = r ? Symbol.for("react.context") : 60110, p = r ? Symbol.for("react.async_mode") : 60111, y = r ? Symbol.for("react.concurrent_mode") : 60111, S = r ? Symbol.for("react.forward_ref") : 60112, w = r ? Symbol.for("react.suspense") : 60113, x = r ? Symbol.for("react.suspense_list") : 60120, _ = r ? Symbol.for("react.memo") : 60115, O = r ? Symbol.for("react.lazy") : 60116, I = r ? Symbol.for("react.block") : 60121, j = r ? Symbol.for("react.fundamental") : 60117, D = r ? Symbol.for("react.responder") : 60118, k = r ? Symbol.for("react.scope") : 60119;
  function L(E) {
    if (typeof E == "object" && E !== null) {
      var z = E.$$typeof;
      switch (z) {
        case o:
          switch (E = E.type, E) {
            case p:
            case y:
            case a:
            case f:
            case i:
            case w:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case d:
                case S:
                case O:
                case _:
                case c:
                  return E;
                default:
                  return z;
              }
          }
        case t:
          return z;
      }
    }
  }
  function $(E) {
    return L(E) === y;
  }
  return fe.AsyncMode = p, fe.ConcurrentMode = y, fe.ContextConsumer = d, fe.ContextProvider = c, fe.Element = o, fe.ForwardRef = S, fe.Fragment = a, fe.Lazy = O, fe.Memo = _, fe.Portal = t, fe.Profiler = f, fe.StrictMode = i, fe.Suspense = w, fe.isAsyncMode = function(E) {
    return $(E) || L(E) === p;
  }, fe.isConcurrentMode = $, fe.isContextConsumer = function(E) {
    return L(E) === d;
  }, fe.isContextProvider = function(E) {
    return L(E) === c;
  }, fe.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === o;
  }, fe.isForwardRef = function(E) {
    return L(E) === S;
  }, fe.isFragment = function(E) {
    return L(E) === a;
  }, fe.isLazy = function(E) {
    return L(E) === O;
  }, fe.isMemo = function(E) {
    return L(E) === _;
  }, fe.isPortal = function(E) {
    return L(E) === t;
  }, fe.isProfiler = function(E) {
    return L(E) === f;
  }, fe.isStrictMode = function(E) {
    return L(E) === i;
  }, fe.isSuspense = function(E) {
    return L(E) === w;
  }, fe.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === a || E === y || E === f || E === i || E === w || E === x || typeof E == "object" && E !== null && (E.$$typeof === O || E.$$typeof === _ || E.$$typeof === c || E.$$typeof === d || E.$$typeof === S || E.$$typeof === j || E.$$typeof === D || E.$$typeof === k || E.$$typeof === I);
  }, fe.typeOf = L, fe;
}
var pe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dn;
function Co() {
  return dn || (dn = 1, process.env.NODE_ENV !== "production" && function() {
    var r = typeof Symbol == "function" && Symbol.for, o = r ? Symbol.for("react.element") : 60103, t = r ? Symbol.for("react.portal") : 60106, a = r ? Symbol.for("react.fragment") : 60107, i = r ? Symbol.for("react.strict_mode") : 60108, f = r ? Symbol.for("react.profiler") : 60114, c = r ? Symbol.for("react.provider") : 60109, d = r ? Symbol.for("react.context") : 60110, p = r ? Symbol.for("react.async_mode") : 60111, y = r ? Symbol.for("react.concurrent_mode") : 60111, S = r ? Symbol.for("react.forward_ref") : 60112, w = r ? Symbol.for("react.suspense") : 60113, x = r ? Symbol.for("react.suspense_list") : 60120, _ = r ? Symbol.for("react.memo") : 60115, O = r ? Symbol.for("react.lazy") : 60116, I = r ? Symbol.for("react.block") : 60121, j = r ? Symbol.for("react.fundamental") : 60117, D = r ? Symbol.for("react.responder") : 60118, k = r ? Symbol.for("react.scope") : 60119;
    function L(R) {
      return typeof R == "string" || typeof R == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      R === a || R === y || R === f || R === i || R === w || R === x || typeof R == "object" && R !== null && (R.$$typeof === O || R.$$typeof === _ || R.$$typeof === c || R.$$typeof === d || R.$$typeof === S || R.$$typeof === j || R.$$typeof === D || R.$$typeof === k || R.$$typeof === I);
    }
    function $(R) {
      if (typeof R == "object" && R !== null) {
        var be = R.$$typeof;
        switch (be) {
          case o:
            var Re = R.type;
            switch (Re) {
              case p:
              case y:
              case a:
              case f:
              case i:
              case w:
                return Re;
              default:
                var X = Re && Re.$$typeof;
                switch (X) {
                  case d:
                  case S:
                  case O:
                  case _:
                  case c:
                    return X;
                  default:
                    return be;
                }
            }
          case t:
            return be;
        }
      }
    }
    var E = p, z = y, oe = d, Ee = c, ue = o, Oe = S, Ae = a, K = O, J = _, Z = t, ye = f, Ie = i, he = w, ve = !1;
    function Ve(R) {
      return ve || (ve = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Le(R) || $(R) === p;
    }
    function Le(R) {
      return $(R) === y;
    }
    function Ye(R) {
      return $(R) === d;
    }
    function M(R) {
      return $(R) === c;
    }
    function F(R) {
      return typeof R == "object" && R !== null && R.$$typeof === o;
    }
    function B(R) {
      return $(R) === S;
    }
    function V(R) {
      return $(R) === a;
    }
    function m(R) {
      return $(R) === O;
    }
    function ee(R) {
      return $(R) === _;
    }
    function T(R) {
      return $(R) === t;
    }
    function de(R) {
      return $(R) === f;
    }
    function te(R) {
      return $(R) === i;
    }
    function ae(R) {
      return $(R) === w;
    }
    pe.AsyncMode = E, pe.ConcurrentMode = z, pe.ContextConsumer = oe, pe.ContextProvider = Ee, pe.Element = ue, pe.ForwardRef = Oe, pe.Fragment = Ae, pe.Lazy = K, pe.Memo = J, pe.Portal = Z, pe.Profiler = ye, pe.StrictMode = Ie, pe.Suspense = he, pe.isAsyncMode = Ve, pe.isConcurrentMode = Le, pe.isContextConsumer = Ye, pe.isContextProvider = M, pe.isElement = F, pe.isForwardRef = B, pe.isFragment = V, pe.isLazy = m, pe.isMemo = ee, pe.isPortal = T, pe.isProfiler = de, pe.isStrictMode = te, pe.isSuspense = ae, pe.isValidElementType = L, pe.typeOf = $;
  }()), pe;
}
process.env.NODE_ENV === "production" ? $r.exports = Oo() : $r.exports = Co();
var dr = $r.exports, To = function(o, t, a, i) {
  var f = a ? a.call(i, o, t) : void 0;
  if (f !== void 0)
    return !!f;
  if (o === t)
    return !0;
  if (typeof o != "object" || !o || typeof t != "object" || !t)
    return !1;
  var c = Object.keys(o), d = Object.keys(t);
  if (c.length !== d.length)
    return !1;
  for (var p = Object.prototype.hasOwnProperty.bind(t), y = 0; y < c.length; y++) {
    var S = c[y];
    if (!p(S))
      return !1;
    var w = o[S], x = t[S];
    if (f = a ? a.call(i, w, x, S) : void 0, f === !1 || f === void 0 && w !== x)
      return !1;
  }
  return !0;
};
const Ao = /* @__PURE__ */ ur(To);
function _o(r) {
  function o(M, F, B, V, m) {
    for (var ee = 0, T = 0, de = 0, te = 0, ae, R, be = 0, Re = 0, X, Ce = X = ae = 0, ie = 0, Te = 0, Ke = 0, v = 0, Q = B.length, qe = Q - 1, De, Y = "", ge = "", nt = "", Ge = "", Xe; ie < Q; ) {
      if (R = B.charCodeAt(ie), ie === qe && T + te + de + ee !== 0 && (T !== 0 && (R = T === 47 ? 10 : 47), te = de = ee = 0, Q++, qe++), T + te + de + ee === 0) {
        if (ie === qe && (0 < Te && (Y = Y.replace(x, "")), 0 < Y.trim().length)) {
          switch (R) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              Y += B.charAt(ie);
          }
          R = 59;
        }
        switch (R) {
          case 123:
            for (Y = Y.trim(), ae = Y.charCodeAt(0), X = 1, v = ++ie; ie < Q; ) {
              switch (R = B.charCodeAt(ie)) {
                case 123:
                  X++;
                  break;
                case 125:
                  X--;
                  break;
                case 47:
                  switch (R = B.charCodeAt(ie + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Ce = ie + 1; Ce < qe; ++Ce)
                          switch (B.charCodeAt(Ce)) {
                            case 47:
                              if (R === 42 && B.charCodeAt(Ce - 1) === 42 && ie + 2 !== Ce) {
                                ie = Ce + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (R === 47) {
                                ie = Ce + 1;
                                break e;
                              }
                          }
                        ie = Ce;
                      }
                  }
                  break;
                case 91:
                  R++;
                case 40:
                  R++;
                case 34:
                case 39:
                  for (; ie++ < qe && B.charCodeAt(ie) !== R; )
                    ;
              }
              if (X === 0)
                break;
              ie++;
            }
            switch (X = B.substring(v, ie), ae === 0 && (ae = (Y = Y.replace(w, "").trim()).charCodeAt(0)), ae) {
              case 64:
                switch (0 < Te && (Y = Y.replace(x, "")), R = Y.charCodeAt(1), R) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    Te = F;
                    break;
                  default:
                    Te = Ie;
                }
                if (X = o(F, Te, X, R, m + 1), v = X.length, 0 < ve && (Te = t(Ie, Y, Ke), Xe = d(3, X, Te, F, J, K, v, R, m, V), Y = Te.join(""), Xe !== void 0 && (v = (X = Xe.trim()).length) === 0 && (R = 0, X = "")), 0 < v)
                  switch (R) {
                    case 115:
                      Y = Y.replace(z, c);
                    case 100:
                    case 109:
                    case 45:
                      X = Y + "{" + X + "}";
                      break;
                    case 107:
                      Y = Y.replace(k, "$1 $2"), X = Y + "{" + X + "}", X = ye === 1 || ye === 2 && f("@" + X, 3) ? "@-webkit-" + X + "@" + X : "@" + X;
                      break;
                    default:
                      X = Y + X, V === 112 && (X = (ge += X, ""));
                  }
                else
                  X = "";
                break;
              default:
                X = o(F, t(F, Y, Ke), X, V, m + 1);
            }
            nt += X, X = Ke = Te = Ce = ae = 0, Y = "", R = B.charCodeAt(++ie);
            break;
          case 125:
          case 59:
            if (Y = (0 < Te ? Y.replace(x, "") : Y).trim(), 1 < (v = Y.length))
              switch (Ce === 0 && (ae = Y.charCodeAt(0), ae === 45 || 96 < ae && 123 > ae) && (v = (Y = Y.replace(" ", ":")).length), 0 < ve && (Xe = d(1, Y, F, M, J, K, ge.length, V, m, V)) !== void 0 && (v = (Y = Xe.trim()).length) === 0 && (Y = "\0\0"), ae = Y.charCodeAt(0), R = Y.charCodeAt(1), ae) {
                case 0:
                  break;
                case 64:
                  if (R === 105 || R === 99) {
                    Ge += Y + B.charAt(ie);
                    break;
                  }
                default:
                  Y.charCodeAt(v - 1) !== 58 && (ge += i(Y, ae, R, Y.charCodeAt(2)));
              }
            Ke = Te = Ce = ae = 0, Y = "", R = B.charCodeAt(++ie);
        }
      }
      switch (R) {
        case 13:
        case 10:
          T === 47 ? T = 0 : 1 + ae === 0 && V !== 107 && 0 < Y.length && (Te = 1, Y += "\0"), 0 < ve * Le && d(0, Y, F, M, J, K, ge.length, V, m, V), K = 1, J++;
          break;
        case 59:
        case 125:
          if (T + te + de + ee === 0) {
            K++;
            break;
          }
        default:
          switch (K++, De = B.charAt(ie), R) {
            case 9:
            case 32:
              if (te + ee + T === 0)
                switch (be) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    De = "";
                    break;
                  default:
                    R !== 32 && (De = " ");
                }
              break;
            case 0:
              De = "\\0";
              break;
            case 12:
              De = "\\f";
              break;
            case 11:
              De = "\\v";
              break;
            case 38:
              te + T + ee === 0 && (Te = Ke = 1, De = "\f" + De);
              break;
            case 108:
              if (te + T + ee + Z === 0 && 0 < Ce)
                switch (ie - Ce) {
                  case 2:
                    be === 112 && B.charCodeAt(ie - 3) === 58 && (Z = be);
                  case 8:
                    Re === 111 && (Z = Re);
                }
              break;
            case 58:
              te + T + ee === 0 && (Ce = ie);
              break;
            case 44:
              T + de + te + ee === 0 && (Te = 1, De += "\r");
              break;
            case 34:
            case 39:
              T === 0 && (te = te === R ? 0 : te === 0 ? R : te);
              break;
            case 91:
              te + T + de === 0 && ee++;
              break;
            case 93:
              te + T + de === 0 && ee--;
              break;
            case 41:
              te + T + ee === 0 && de--;
              break;
            case 40:
              if (te + T + ee === 0) {
                if (ae === 0)
                  switch (2 * be + 3 * Re) {
                    case 533:
                      break;
                    default:
                      ae = 1;
                  }
                de++;
              }
              break;
            case 64:
              T + de + te + ee + Ce + X === 0 && (X = 1);
              break;
            case 42:
            case 47:
              if (!(0 < te + ee + de))
                switch (T) {
                  case 0:
                    switch (2 * R + 3 * B.charCodeAt(ie + 1)) {
                      case 235:
                        T = 47;
                        break;
                      case 220:
                        v = ie, T = 42;
                    }
                    break;
                  case 42:
                    R === 47 && be === 42 && v + 2 !== ie && (B.charCodeAt(v + 2) === 33 && (ge += B.substring(v, ie + 1)), De = "", T = 0);
                }
          }
          T === 0 && (Y += De);
      }
      Re = be, be = R, ie++;
    }
    if (v = ge.length, 0 < v) {
      if (Te = F, 0 < ve && (Xe = d(2, ge, Te, M, J, K, v, V, m, V), Xe !== void 0 && (ge = Xe).length === 0))
        return Ge + ge + nt;
      if (ge = Te.join(",") + "{" + ge + "}", ye * Z !== 0) {
        switch (ye !== 2 || f(ge, 2) || (Z = 0), Z) {
          case 111:
            ge = ge.replace($, ":-moz-$1") + ge;
            break;
          case 112:
            ge = ge.replace(L, "::-webkit-input-$1") + ge.replace(L, "::-moz-$1") + ge.replace(L, ":-ms-input-$1") + ge;
        }
        Z = 0;
      }
    }
    return Ge + ge + nt;
  }
  function t(M, F, B) {
    var V = F.trim().split(j);
    F = V;
    var m = V.length, ee = M.length;
    switch (ee) {
      case 0:
      case 1:
        var T = 0;
        for (M = ee === 0 ? "" : M[0] + " "; T < m; ++T)
          F[T] = a(M, F[T], B).trim();
        break;
      default:
        var de = T = 0;
        for (F = []; T < m; ++T)
          for (var te = 0; te < ee; ++te)
            F[de++] = a(M[te] + " ", V[T], B).trim();
    }
    return F;
  }
  function a(M, F, B) {
    var V = F.charCodeAt(0);
    switch (33 > V && (V = (F = F.trim()).charCodeAt(0)), V) {
      case 38:
        return F.replace(D, "$1" + M.trim());
      case 58:
        return M.trim() + F.replace(D, "$1" + M.trim());
      default:
        if (0 < 1 * B && 0 < F.indexOf("\f"))
          return F.replace(D, (M.charCodeAt(0) === 58 ? "" : "$1") + M.trim());
    }
    return M + F;
  }
  function i(M, F, B, V) {
    var m = M + ";", ee = 2 * F + 3 * B + 4 * V;
    if (ee === 944) {
      M = m.indexOf(":", 9) + 1;
      var T = m.substring(M, m.length - 1).trim();
      return T = m.substring(0, M).trim() + T + ";", ye === 1 || ye === 2 && f(T, 1) ? "-webkit-" + T + T : T;
    }
    if (ye === 0 || ye === 2 && !f(m, 1))
      return m;
    switch (ee) {
      case 1015:
        return m.charCodeAt(10) === 97 ? "-webkit-" + m + m : m;
      case 951:
        return m.charCodeAt(3) === 116 ? "-webkit-" + m + m : m;
      case 963:
        return m.charCodeAt(5) === 110 ? "-webkit-" + m + m : m;
      case 1009:
        if (m.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + m + m;
      case 978:
        return "-webkit-" + m + "-moz-" + m + m;
      case 1019:
      case 983:
        return "-webkit-" + m + "-moz-" + m + "-ms-" + m + m;
      case 883:
        if (m.charCodeAt(8) === 45)
          return "-webkit-" + m + m;
        if (0 < m.indexOf("image-set(", 11))
          return m.replace(Ae, "$1-webkit-$2") + m;
        break;
      case 932:
        if (m.charCodeAt(4) === 45)
          switch (m.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + m.replace("-grow", "") + "-webkit-" + m + "-ms-" + m.replace("grow", "positive") + m;
            case 115:
              return "-webkit-" + m + "-ms-" + m.replace("shrink", "negative") + m;
            case 98:
              return "-webkit-" + m + "-ms-" + m.replace("basis", "preferred-size") + m;
          }
        return "-webkit-" + m + "-ms-" + m + m;
      case 964:
        return "-webkit-" + m + "-ms-flex-" + m + m;
      case 1023:
        if (m.charCodeAt(8) !== 99)
          break;
        return T = m.substring(m.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + T + "-webkit-" + m + "-ms-flex-pack" + T + m;
      case 1005:
        return O.test(m) ? m.replace(_, ":-webkit-") + m.replace(_, ":-moz-") + m : m;
      case 1e3:
        switch (T = m.substring(13).trim(), F = T.indexOf("-") + 1, T.charCodeAt(0) + T.charCodeAt(F)) {
          case 226:
            T = m.replace(E, "tb");
            break;
          case 232:
            T = m.replace(E, "tb-rl");
            break;
          case 220:
            T = m.replace(E, "lr");
            break;
          default:
            return m;
        }
        return "-webkit-" + m + "-ms-" + T + m;
      case 1017:
        if (m.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (F = (m = M).length - 10, T = (m.charCodeAt(F) === 33 ? m.substring(0, F) : m).substring(M.indexOf(":", 7) + 1).trim(), ee = T.charCodeAt(0) + (T.charCodeAt(7) | 0)) {
          case 203:
            if (111 > T.charCodeAt(8))
              break;
          case 115:
            m = m.replace(T, "-webkit-" + T) + ";" + m;
            break;
          case 207:
          case 102:
            m = m.replace(T, "-webkit-" + (102 < ee ? "inline-" : "") + "box") + ";" + m.replace(T, "-webkit-" + T) + ";" + m.replace(T, "-ms-" + T + "box") + ";" + m;
        }
        return m + ";";
      case 938:
        if (m.charCodeAt(5) === 45)
          switch (m.charCodeAt(6)) {
            case 105:
              return T = m.replace("-items", ""), "-webkit-" + m + "-webkit-box-" + T + "-ms-flex-" + T + m;
            case 115:
              return "-webkit-" + m + "-ms-flex-item-" + m.replace(Ee, "") + m;
            default:
              return "-webkit-" + m + "-ms-flex-line-pack" + m.replace("align-content", "").replace(Ee, "") + m;
          }
        break;
      case 973:
      case 989:
        if (m.charCodeAt(3) !== 45 || m.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (Oe.test(M) === !0)
          return (T = M.substring(M.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(M.replace("stretch", "fill-available"), F, B, V).replace(":fill-available", ":stretch") : m.replace(T, "-webkit-" + T) + m.replace(T, "-moz-" + T.replace("fill-", "")) + m;
        break;
      case 962:
        if (m = "-webkit-" + m + (m.charCodeAt(5) === 102 ? "-ms-" + m : "") + m, B + V === 211 && m.charCodeAt(13) === 105 && 0 < m.indexOf("transform", 10))
          return m.substring(0, m.indexOf(";", 27) + 1).replace(I, "$1-webkit-$2") + m;
    }
    return m;
  }
  function f(M, F) {
    var B = M.indexOf(F === 1 ? ":" : "{"), V = M.substring(0, F !== 3 ? B : 10);
    return B = M.substring(B + 1, M.length - 1), Ve(F !== 2 ? V : V.replace(ue, "$1"), B, F);
  }
  function c(M, F) {
    var B = i(F, F.charCodeAt(0), F.charCodeAt(1), F.charCodeAt(2));
    return B !== F + ";" ? B.replace(oe, " or ($1)").substring(4) : "(" + F + ")";
  }
  function d(M, F, B, V, m, ee, T, de, te, ae) {
    for (var R = 0, be = F, Re; R < ve; ++R)
      switch (Re = he[R].call(S, M, be, B, V, m, ee, T, de, te, ae)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          be = Re;
      }
    if (be !== F)
      return be;
  }
  function p(M) {
    switch (M) {
      case void 0:
      case null:
        ve = he.length = 0;
        break;
      default:
        if (typeof M == "function")
          he[ve++] = M;
        else if (typeof M == "object")
          for (var F = 0, B = M.length; F < B; ++F)
            p(M[F]);
        else
          Le = !!M | 0;
    }
    return p;
  }
  function y(M) {
    return M = M.prefix, M !== void 0 && (Ve = null, M ? typeof M != "function" ? ye = 1 : (ye = 2, Ve = M) : ye = 0), y;
  }
  function S(M, F) {
    var B = M;
    if (33 > B.charCodeAt(0) && (B = B.trim()), Ye = B, B = [Ye], 0 < ve) {
      var V = d(-1, F, B, B, J, K, 0, 0, 0, 0);
      V !== void 0 && typeof V == "string" && (F = V);
    }
    var m = o(Ie, B, F, 0, 0);
    return 0 < ve && (V = d(-2, m, B, B, J, K, m.length, 0, 0, 0), V !== void 0 && (m = V)), Ye = "", Z = 0, K = J = 1, m;
  }
  var w = /^\0+/g, x = /[\0\r\f]/g, _ = /: */g, O = /zoo|gra/, I = /([,: ])(transform)/g, j = /,\r+?/g, D = /([\t\r\n ])*\f?&/g, k = /@(k\w+)\s*(\S*)\s*/, L = /::(place)/g, $ = /:(read-only)/g, E = /[svh]\w+-[tblr]{2}/, z = /\(\s*(.*)\s*\)/g, oe = /([\s\S]*?);/g, Ee = /-self|flex-/g, ue = /[^]*?(:[rp][el]a[\w-]+)[^]*/, Oe = /stretch|:\s*\w+\-(?:conte|avail)/, Ae = /([^-])(image-set\()/, K = 1, J = 1, Z = 0, ye = 1, Ie = [], he = [], ve = 0, Ve = null, Le = 0, Ye = "";
  return S.use = p, S.set = y, r !== void 0 && y(r), S;
}
var Po = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function ko(r) {
  var o = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return o[t] === void 0 && (o[t] = r(t)), o[t];
  };
}
var No = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, fn = /* @__PURE__ */ ko(
  function(r) {
    return No.test(r) || r.charCodeAt(0) === 111 && r.charCodeAt(1) === 110 && r.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Yr = dr, jo = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Io = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Do = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Fn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, qr = {};
qr[Yr.ForwardRef] = Do;
qr[Yr.Memo] = Fn;
function pn(r) {
  return Yr.isMemo(r) ? Fn : qr[r.$$typeof] || jo;
}
var Lo = Object.defineProperty, $o = Object.getOwnPropertyNames, hn = Object.getOwnPropertySymbols, Fo = Object.getOwnPropertyDescriptor, Bo = Object.getPrototypeOf, mn = Object.prototype;
function Bn(r, o, t) {
  if (typeof o != "string") {
    if (mn) {
      var a = Bo(o);
      a && a !== mn && Bn(r, a, t);
    }
    var i = $o(o);
    hn && (i = i.concat(hn(o)));
    for (var f = pn(r), c = pn(o), d = 0; d < i.length; ++d) {
      var p = i[d];
      if (!Io[p] && !(t && t[p]) && !(c && c[p]) && !(f && f[p])) {
        var y = Fo(o, p);
        try {
          Lo(r, p, y);
        } catch {
        }
      }
    }
  }
  return r;
}
var Mo = Bn;
const Mn = /* @__PURE__ */ ur(Mo);
function ze() {
  return (ze = Object.assign || function(r) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (r[a] = t[a]);
    }
    return r;
  }).apply(this, arguments);
}
var gn = function(r, o) {
  for (var t = [r[0]], a = 0, i = o.length; a < i; a += 1)
    t.push(o[a], r[a + 1]);
  return t;
}, Fr = function(r) {
  return r !== null && typeof r == "object" && (r.toString ? r.toString() : Object.prototype.toString.call(r)) === "[object Object]" && !dr.typeOf(r);
}, sr = Object.freeze([]), dt = Object.freeze({});
function Ct(r) {
  return typeof r == "function";
}
function $t(r) {
  return process.env.NODE_ENV !== "production" && typeof r == "string" && r || r.displayName || r.name || "Component";
}
function fr(r) {
  return r && typeof r.styledComponentId == "string";
}
var ft = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", zo = "5.3.11", Gr = typeof window < "u" && "HTMLElement" in window, Uo = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production")), Wo = {}, Ho = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function Vo() {
  for (var r = arguments.length <= 0 ? void 0 : arguments[0], o = [], t = 1, a = arguments.length; t < a; t += 1)
    o.push(t < 0 || arguments.length <= t ? void 0 : arguments[t]);
  return o.forEach(function(i) {
    r = r.replace(/%[a-z]/, i);
  }), r;
}
function Ue(r) {
  for (var o = arguments.length, t = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
    t[a - 1] = arguments[a];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + r + " for more information." + (t.length > 0 ? " Args: " + t.join(", ") : "")) : new Error(Vo.apply(void 0, [Ho[r]].concat(t)).trim());
}
var Yo = function() {
  function r(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  var o = r.prototype;
  return o.indexOfGroup = function(t) {
    for (var a = 0, i = 0; i < t; i++)
      a += this.groupSizes[i];
    return a;
  }, o.insertRules = function(t, a) {
    if (t >= this.groupSizes.length) {
      for (var i = this.groupSizes, f = i.length, c = f; t >= c; )
        (c <<= 1) < 0 && Ue(16, "" + t);
      this.groupSizes = new Uint32Array(c), this.groupSizes.set(i), this.length = c;
      for (var d = f; d < c; d++)
        this.groupSizes[d] = 0;
    }
    for (var p = this.indexOfGroup(t + 1), y = 0, S = a.length; y < S; y++)
      this.tag.insertRule(p, a[y]) && (this.groupSizes[t]++, p++);
  }, o.clearGroup = function(t) {
    if (t < this.length) {
      var a = this.groupSizes[t], i = this.indexOfGroup(t), f = i + a;
      this.groupSizes[t] = 0;
      for (var c = i; c < f; c++)
        this.tag.deleteRule(i);
    }
  }, o.getGroup = function(t) {
    var a = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return a;
    for (var i = this.groupSizes[t], f = this.indexOfGroup(t), c = f + i, d = f; d < c; d++)
      a += this.tag.getRule(d) + `/*!sc*/
`;
    return a;
  }, r;
}(), ir = /* @__PURE__ */ new Map(), cr = /* @__PURE__ */ new Map(), Lt = 1, tr = function(r) {
  if (ir.has(r))
    return ir.get(r);
  for (; cr.has(Lt); )
    Lt++;
  var o = Lt++;
  return process.env.NODE_ENV !== "production" && ((0 | o) < 0 || o > 1 << 30) && Ue(16, "" + o), ir.set(r, o), cr.set(o, r), o;
}, qo = function(r) {
  return cr.get(r);
}, Go = function(r, o) {
  o >= Lt && (Lt = o + 1), ir.set(r, o), cr.set(o, r);
}, Xo = "style[" + ft + '][data-styled-version="5.3.11"]', Jo = new RegExp("^" + ft + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Ko = function(r, o, t) {
  for (var a, i = t.split(","), f = 0, c = i.length; f < c; f++)
    (a = i[f]) && r.registerName(o, a);
}, Zo = function(r, o) {
  for (var t = (o.textContent || "").split(`/*!sc*/
`), a = [], i = 0, f = t.length; i < f; i++) {
    var c = t[i].trim();
    if (c) {
      var d = c.match(Jo);
      if (d) {
        var p = 0 | parseInt(d[1], 10), y = d[2];
        p !== 0 && (Go(y, p), Ko(r, y, d[3]), r.getTag().insertRules(p, a)), a.length = 0;
      } else
        a.push(c);
    }
  }
}, Br = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, zn = function(r) {
  var o = document.head, t = r || o, a = document.createElement("style"), i = function(d) {
    for (var p = d.childNodes, y = p.length; y >= 0; y--) {
      var S = p[y];
      if (S && S.nodeType === 1 && S.hasAttribute(ft))
        return S;
    }
  }(t), f = i !== void 0 ? i.nextSibling : null;
  a.setAttribute(ft, "active"), a.setAttribute("data-styled-version", "5.3.11");
  var c = Br();
  return c && a.setAttribute("nonce", c), t.insertBefore(a, f), a;
}, Qo = function() {
  function r(t) {
    var a = this.element = zn(t);
    a.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet)
        return i.sheet;
      for (var f = document.styleSheets, c = 0, d = f.length; c < d; c++) {
        var p = f[c];
        if (p.ownerNode === i)
          return p;
      }
      Ue(17);
    }(a), this.length = 0;
  }
  var o = r.prototype;
  return o.insertRule = function(t, a) {
    try {
      return this.sheet.insertRule(a, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, o.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, o.getRule = function(t) {
    var a = this.sheet.cssRules[t];
    return a !== void 0 && typeof a.cssText == "string" ? a.cssText : "";
  }, r;
}(), ea = function() {
  function r(t) {
    var a = this.element = zn(t);
    this.nodes = a.childNodes, this.length = 0;
  }
  var o = r.prototype;
  return o.insertRule = function(t, a) {
    if (t <= this.length && t >= 0) {
      var i = document.createTextNode(a), f = this.nodes[t];
      return this.element.insertBefore(i, f || null), this.length++, !0;
    }
    return !1;
  }, o.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, o.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, r;
}(), ta = function() {
  function r(t) {
    this.rules = [], this.length = 0;
  }
  var o = r.prototype;
  return o.insertRule = function(t, a) {
    return t <= this.length && (this.rules.splice(t, 0, a), this.length++, !0);
  }, o.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, o.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, r;
}(), yn = Gr, ra = { isServer: !Gr, useCSSOMInjection: !Uo }, Tt = function() {
  function r(t, a, i) {
    t === void 0 && (t = dt), a === void 0 && (a = {}), this.options = ze({}, ra, {}, t), this.gs = a, this.names = new Map(i), this.server = !!t.isServer, !this.server && Gr && yn && (yn = !1, function(f) {
      for (var c = document.querySelectorAll(Xo), d = 0, p = c.length; d < p; d++) {
        var y = c[d];
        y && y.getAttribute(ft) !== "active" && (Zo(f, y), y.parentNode && y.parentNode.removeChild(y));
      }
    }(this));
  }
  r.registerId = function(t) {
    return tr(t);
  };
  var o = r.prototype;
  return o.reconstructWithOptions = function(t, a) {
    return a === void 0 && (a = !0), new r(ze({}, this.options, {}, t), this.gs, a && this.names || void 0);
  }, o.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, o.getTag = function() {
    return this.tag || (this.tag = (i = (a = this.options).isServer, f = a.useCSSOMInjection, c = a.target, t = i ? new ta(c) : f ? new Qo(c) : new ea(c), new Yo(t)));
    var t, a, i, f, c;
  }, o.hasNameForId = function(t, a) {
    return this.names.has(t) && this.names.get(t).has(a);
  }, o.registerName = function(t, a) {
    if (tr(t), this.names.has(t))
      this.names.get(t).add(a);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(a), this.names.set(t, i);
    }
  }, o.insertRules = function(t, a, i) {
    this.registerName(t, a), this.getTag().insertRules(tr(t), i);
  }, o.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, o.clearRules = function(t) {
    this.getTag().clearGroup(tr(t)), this.clearNames(t);
  }, o.clearTag = function() {
    this.tag = void 0;
  }, o.toString = function() {
    return function(t) {
      for (var a = t.getTag(), i = a.length, f = "", c = 0; c < i; c++) {
        var d = qo(c);
        if (d !== void 0) {
          var p = t.names.get(d), y = a.getGroup(c);
          if (p && y && p.size) {
            var S = ft + ".g" + c + '[id="' + d + '"]', w = "";
            p !== void 0 && p.forEach(function(x) {
              x.length > 0 && (w += x + ",");
            }), f += "" + y + S + '{content:"' + w + `"}/*!sc*/
`;
          }
        }
      }
      return f;
    }(this);
  }, r;
}(), na = /(a)(d)/gi, vn = function(r) {
  return String.fromCharCode(r + (r > 25 ? 39 : 97));
};
function Mr(r) {
  var o, t = "";
  for (o = Math.abs(r); o > 52; o = o / 52 | 0)
    t = vn(o % 52) + t;
  return (vn(o % 52) + t).replace(na, "$1-$2");
}
var vt = function(r, o) {
  for (var t = o.length; t; )
    r = 33 * r ^ o.charCodeAt(--t);
  return r;
}, Un = function(r) {
  return vt(5381, r);
};
function Wn(r) {
  for (var o = 0; o < r.length; o += 1) {
    var t = r[o];
    if (Ct(t) && !fr(t))
      return !1;
  }
  return !0;
}
var oa = Un("5.3.11"), aa = function() {
  function r(o, t, a) {
    this.rules = o, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (a === void 0 || a.isStatic) && Wn(o), this.componentId = t, this.baseHash = vt(oa, t), this.baseStyle = a, Tt.registerId(t);
  }
  return r.prototype.generateAndInjectStyles = function(o, t, a) {
    var i = this.componentId, f = [];
    if (this.baseStyle && f.push(this.baseStyle.generateAndInjectStyles(o, t, a)), this.isStatic && !a.hash)
      if (this.staticRulesId && t.hasNameForId(i, this.staticRulesId))
        f.push(this.staticRulesId);
      else {
        var c = bt(this.rules, o, t, a).join(""), d = Mr(vt(this.baseHash, c) >>> 0);
        if (!t.hasNameForId(i, d)) {
          var p = a(c, "." + d, void 0, i);
          t.insertRules(i, d, p);
        }
        f.push(d), this.staticRulesId = d;
      }
    else {
      for (var y = this.rules.length, S = vt(this.baseHash, a.hash), w = "", x = 0; x < y; x++) {
        var _ = this.rules[x];
        if (typeof _ == "string")
          w += _, process.env.NODE_ENV !== "production" && (S = vt(S, _ + x));
        else if (_) {
          var O = bt(_, o, t, a), I = Array.isArray(O) ? O.join("") : O;
          S = vt(S, I + x), w += I;
        }
      }
      if (w) {
        var j = Mr(S >>> 0);
        if (!t.hasNameForId(i, j)) {
          var D = a(w, "." + j, void 0, i);
          t.insertRules(i, j, D);
        }
        f.push(j);
      }
    }
    return f.join(" ");
  }, r;
}(), ia = /^\s*\/\/.*$/gm, sa = [":", "[", ".", "#"];
function Hn(r) {
  var o, t, a, i, f = r === void 0 ? dt : r, c = f.options, d = c === void 0 ? dt : c, p = f.plugins, y = p === void 0 ? sr : p, S = new _o(d), w = [], x = function(I) {
    function j(D) {
      if (D)
        try {
          I(D + "}");
        } catch {
        }
    }
    return function(D, k, L, $, E, z, oe, Ee, ue, Oe) {
      switch (D) {
        case 1:
          if (ue === 0 && k.charCodeAt(0) === 64)
            return I(k + ";"), "";
          break;
        case 2:
          if (Ee === 0)
            return k + "/*|*/";
          break;
        case 3:
          switch (Ee) {
            case 102:
            case 112:
              return I(L[0] + k), "";
            default:
              return k + (Oe === 0 ? "/*|*/" : "");
          }
        case -2:
          k.split("/*|*/}").forEach(j);
      }
    };
  }(function(I) {
    w.push(I);
  }), _ = function(I, j, D) {
    return j === 0 && sa.indexOf(D[t.length]) !== -1 || D.match(i) ? I : "." + o;
  };
  function O(I, j, D, k) {
    k === void 0 && (k = "&");
    var L = I.replace(ia, ""), $ = j && D ? D + " " + j + " { " + L + " }" : L;
    return o = k, t = j, a = new RegExp("\\" + t + "\\b", "g"), i = new RegExp("(\\" + t + "\\b){2,}"), S(D || !j ? "" : j, $);
  }
  return S.use([].concat(y, [function(I, j, D) {
    I === 2 && D.length && D[0].lastIndexOf(t) > 0 && (D[0] = D[0].replace(a, _));
  }, x, function(I) {
    if (I === -2) {
      var j = w;
      return w = [], j;
    }
  }])), O.hash = y.length ? y.reduce(function(I, j) {
    return j.name || Ue(15), vt(I, j.name);
  }, 5381).toString() : "", O;
}
var pr = ke.createContext(), ca = pr.Consumer, Xr = ke.createContext(), Vn = (Xr.Consumer, new Tt()), zr = Hn();
function Jr() {
  return St(pr) || Vn;
}
function Yn() {
  return St(Xr) || zr;
}
function qn(r) {
  var o = jn(r.stylisPlugins), t = o[0], a = o[1], i = Jr(), f = Dr(function() {
    var d = i;
    return r.sheet ? d = r.sheet : r.target && (d = d.reconstructWithOptions({ target: r.target }, !1)), r.disableCSSOMInjection && (d = d.reconstructWithOptions({ useCSSOMInjection: !1 })), d;
  }, [r.disableCSSOMInjection, r.sheet, r.target]), c = Dr(function() {
    return Hn({ options: { prefix: !r.disableVendorPrefixes }, plugins: t });
  }, [r.disableVendorPrefixes, t]);
  return In(function() {
    Ao(t, r.stylisPlugins) || a(r.stylisPlugins);
  }, [r.stylisPlugins]), ke.createElement(pr.Provider, { value: f }, ke.createElement(Xr.Provider, { value: c }, process.env.NODE_ENV !== "production" ? ke.Children.only(r.children) : r.children));
}
var Gn = function() {
  function r(o, t) {
    var a = this;
    this.inject = function(i, f) {
      f === void 0 && (f = zr);
      var c = a.name + f.hash;
      i.hasNameForId(a.id, c) || i.insertRules(a.id, c, f(a.rules, c, "@keyframes"));
    }, this.toString = function() {
      return Ue(12, String(a.name));
    }, this.name = o, this.id = "sc-keyframes-" + o, this.rules = t;
  }
  return r.prototype.getName = function(o) {
    return o === void 0 && (o = zr), this.name + o.hash;
  }, r;
}(), la = /([A-Z])/, ua = /([A-Z])/g, da = /^ms-/, fa = function(r) {
  return "-" + r.toLowerCase();
};
function bn(r) {
  return la.test(r) ? r.replace(ua, fa).replace(da, "-ms-") : r;
}
var Sn = function(r) {
  return r == null || r === !1 || r === "";
};
function bt(r, o, t, a) {
  if (Array.isArray(r)) {
    for (var i, f = [], c = 0, d = r.length; c < d; c += 1)
      (i = bt(r[c], o, t, a)) !== "" && (Array.isArray(i) ? f.push.apply(f, i) : f.push(i));
    return f;
  }
  if (Sn(r))
    return "";
  if (fr(r))
    return "." + r.styledComponentId;
  if (Ct(r)) {
    if (typeof (y = r) != "function" || y.prototype && y.prototype.isReactComponent || !o)
      return r;
    var p = r(o);
    return process.env.NODE_ENV !== "production" && dr.isElement(p) && console.warn($t(r) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), bt(p, o, t, a);
  }
  var y;
  return r instanceof Gn ? t ? (r.inject(t, a), r.getName(a)) : r : Fr(r) ? function S(w, x) {
    var _, O, I = [];
    for (var j in w)
      w.hasOwnProperty(j) && !Sn(w[j]) && (Array.isArray(w[j]) && w[j].isCss || Ct(w[j]) ? I.push(bn(j) + ":", w[j], ";") : Fr(w[j]) ? I.push.apply(I, S(w[j], j)) : I.push(bn(j) + ": " + (_ = j, (O = w[j]) == null || typeof O == "boolean" || O === "" ? "" : typeof O != "number" || O === 0 || _ in Po || _.startsWith("--") ? String(O).trim() : O + "px") + ";"));
    return x ? [x + " {"].concat(I, ["}"]) : I;
  }(r) : r.toString();
}
var wn = function(r) {
  return Array.isArray(r) && (r.isCss = !0), r;
};
function hr(r) {
  for (var o = arguments.length, t = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
    t[a - 1] = arguments[a];
  return Ct(r) || Fr(r) ? wn(bt(gn(sr, [r].concat(t)))) : t.length === 0 && r.length === 1 && typeof r[0] == "string" ? r : wn(bt(gn(r, t)));
}
var En = /invalid hook call/i, rr = /* @__PURE__ */ new Set(), Xn = function(r, o) {
  if (process.env.NODE_ENV !== "production") {
    var t = "The component " + r + (o ? ' with the id of "' + o + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, a = console.error;
    try {
      var i = !0;
      console.error = function(f) {
        if (En.test(f))
          i = !1, rr.delete(t);
        else {
          for (var c = arguments.length, d = new Array(c > 1 ? c - 1 : 0), p = 1; p < c; p++)
            d[p - 1] = arguments[p];
          a.apply(void 0, [f].concat(d));
        }
      }, Dn(), i && !rr.has(t) && (console.warn(t), rr.add(t));
    } catch (f) {
      En.test(f.message) && rr.delete(t);
    } finally {
      console.error = a;
    }
  }
}, Kr = function(r, o, t) {
  return t === void 0 && (t = dt), r.theme !== t.theme && r.theme || o || t.theme;
}, pa = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, ha = /(^-|-$)/g;
function Ar(r) {
  return r.replace(pa, "-").replace(ha, "");
}
var Zr = function(r) {
  return Mr(Un(r) >>> 0);
};
function nr(r) {
  return typeof r == "string" && (process.env.NODE_ENV === "production" || r.charAt(0) === r.charAt(0).toLowerCase());
}
var Ur = function(r) {
  return typeof r == "function" || typeof r == "object" && r !== null && !Array.isArray(r);
}, ma = function(r) {
  return r !== "__proto__" && r !== "constructor" && r !== "prototype";
};
function ga(r, o, t) {
  var a = r[t];
  Ur(o) && Ur(a) ? Jn(a, o) : r[t] = o;
}
function Jn(r) {
  for (var o = arguments.length, t = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
    t[a - 1] = arguments[a];
  for (var i = 0, f = t; i < f.length; i++) {
    var c = f[i];
    if (Ur(c))
      for (var d in c)
        ma(d) && ga(r, c[d], d);
  }
  return r;
}
var pt = ke.createContext(), ya = pt.Consumer;
function va(r) {
  var o = St(pt), t = Dr(function() {
    return function(a, i) {
      if (!a)
        return Ue(14);
      if (Ct(a)) {
        var f = a(i);
        return process.env.NODE_ENV === "production" || f !== null && !Array.isArray(f) && typeof f == "object" ? f : Ue(7);
      }
      return Array.isArray(a) || typeof a != "object" ? Ue(8) : i ? ze({}, i, {}, a) : a;
    }(r.theme, o);
  }, [r.theme, o]);
  return r.children ? ke.createElement(pt.Provider, { value: t }, r.children) : null;
}
var _r = {};
function Kn(r, o, t) {
  var a = fr(r), i = !nr(r), f = o.attrs, c = f === void 0 ? sr : f, d = o.componentId, p = d === void 0 ? function(k, L) {
    var $ = typeof k != "string" ? "sc" : Ar(k);
    _r[$] = (_r[$] || 0) + 1;
    var E = $ + "-" + Zr("5.3.11" + $ + _r[$]);
    return L ? L + "-" + E : E;
  }(o.displayName, o.parentComponentId) : d, y = o.displayName, S = y === void 0 ? function(k) {
    return nr(k) ? "styled." + k : "Styled(" + $t(k) + ")";
  }(r) : y, w = o.displayName && o.componentId ? Ar(o.displayName) + "-" + o.componentId : o.componentId || p, x = a && r.attrs ? Array.prototype.concat(r.attrs, c).filter(Boolean) : c, _ = o.shouldForwardProp;
  a && r.shouldForwardProp && (_ = o.shouldForwardProp ? function(k, L, $) {
    return r.shouldForwardProp(k, L, $) && o.shouldForwardProp(k, L, $);
  } : r.shouldForwardProp);
  var O, I = new aa(t, w, a ? r.componentStyle : void 0), j = I.isStatic && c.length === 0, D = function(k, L) {
    return function($, E, z, oe) {
      var Ee = $.attrs, ue = $.componentStyle, Oe = $.defaultProps, Ae = $.foldedComponentIds, K = $.shouldForwardProp, J = $.styledComponentId, Z = $.target, ye = function(V, m, ee) {
        V === void 0 && (V = dt);
        var T = ze({}, m, { theme: V }), de = {};
        return ee.forEach(function(te) {
          var ae, R, be, Re = te;
          for (ae in Ct(Re) && (Re = Re(T)), Re)
            T[ae] = de[ae] = ae === "className" ? (R = de[ae], be = Re[ae], R && be ? R + " " + be : R || be) : Re[ae];
        }), [T, de];
      }(Kr(E, St(pt), Oe) || dt, E, Ee), Ie = ye[0], he = ye[1], ve = function(V, m, ee, T) {
        var de = Jr(), te = Yn(), ae = m ? V.generateAndInjectStyles(dt, de, te) : V.generateAndInjectStyles(ee, de, te);
        return process.env.NODE_ENV !== "production" && !m && T && T(ae), ae;
      }(ue, oe, Ie, process.env.NODE_ENV !== "production" ? $.warnTooManyClasses : void 0), Ve = z, Le = he.$as || E.$as || he.as || E.as || Z, Ye = nr(Le), M = he !== E ? ze({}, E, {}, he) : E, F = {};
      for (var B in M)
        B[0] !== "$" && B !== "as" && (B === "forwardedAs" ? F.as = M[B] : (K ? K(B, fn, Le) : !Ye || fn(B)) && (F[B] = M[B]));
      return E.style && he.style !== E.style && (F.style = ze({}, E.style, {}, he.style)), F.className = Array.prototype.concat(Ae, J, ve !== J ? ve : null, E.className, he.className).filter(Boolean).join(" "), F.ref = Ve, yo(Le, F);
    }(O, k, L, j);
  };
  return D.displayName = S, (O = ke.forwardRef(D)).attrs = x, O.componentStyle = I, O.displayName = S, O.shouldForwardProp = _, O.foldedComponentIds = a ? Array.prototype.concat(r.foldedComponentIds, r.styledComponentId) : sr, O.styledComponentId = w, O.target = a ? r.target : r, O.withComponent = function(k) {
    var L = o.componentId, $ = function(z, oe) {
      if (z == null)
        return {};
      var Ee, ue, Oe = {}, Ae = Object.keys(z);
      for (ue = 0; ue < Ae.length; ue++)
        Ee = Ae[ue], oe.indexOf(Ee) >= 0 || (Oe[Ee] = z[Ee]);
      return Oe;
    }(o, ["componentId"]), E = L && L + "-" + (nr(k) ? k : Ar($t(k)));
    return Kn(k, ze({}, $, { attrs: x, componentId: E }), t);
  }, Object.defineProperty(O, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(k) {
    this._foldedDefaultProps = a ? Jn({}, r.defaultProps, k) : k;
  } }), process.env.NODE_ENV !== "production" && (Xn(S, w), O.warnTooManyClasses = function(k, L) {
    var $ = {}, E = !1;
    return function(z) {
      if (!E && ($[z] = !0, Object.keys($).length >= 200)) {
        var oe = L ? ' with the id of "' + L + '"' : "";
        console.warn("Over 200 classes were generated for component " + k + oe + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), E = !0, $ = {};
      }
    };
  }(S, w)), Object.defineProperty(O, "toString", { value: function() {
    return "." + O.styledComponentId;
  } }), i && Mn(O, r, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), O;
}
var Wr = function(r) {
  return function o(t, a, i) {
    if (i === void 0 && (i = dt), !dr.isValidElementType(a))
      return Ue(1, String(a));
    var f = function() {
      return t(a, i, hr.apply(void 0, arguments));
    };
    return f.withConfig = function(c) {
      return o(t, a, ze({}, i, {}, c));
    }, f.attrs = function(c) {
      return o(t, a, ze({}, i, { attrs: Array.prototype.concat(i.attrs, c).filter(Boolean) }));
    }, f;
  }(Kn, r);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(r) {
  Wr[r] = Wr(r);
});
var ba = function() {
  function r(t, a) {
    this.rules = t, this.componentId = a, this.isStatic = Wn(t), Tt.registerId(this.componentId + 1);
  }
  var o = r.prototype;
  return o.createStyles = function(t, a, i, f) {
    var c = f(bt(this.rules, a, i, f).join(""), ""), d = this.componentId + t;
    i.insertRules(d, d, c);
  }, o.removeStyles = function(t, a) {
    a.clearRules(this.componentId + t);
  }, o.renderStyles = function(t, a, i, f) {
    t > 2 && Tt.registerId(this.componentId + t), this.removeStyles(t, i), this.createStyles(t, a, i, f);
  }, r;
}();
function Sa(r) {
  for (var o = arguments.length, t = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
    t[a - 1] = arguments[a];
  var i = hr.apply(void 0, [r].concat(t)), f = "sc-global-" + Zr(JSON.stringify(i)), c = new ba(i, f);
  function d(y) {
    var S = Jr(), w = Yn(), x = St(pt), _ = Dn(S.allocateGSInstance(f)).current;
    return process.env.NODE_ENV !== "production" && ke.Children.count(y.children) && console.warn("The global style component " + f + " was given child JSX. createGlobalStyle does not render children."), process.env.NODE_ENV !== "production" && i.some(function(O) {
      return typeof O == "string" && O.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), S.server && p(_, y, S, x, w), go(function() {
      if (!S.server)
        return p(_, y, S, x, w), function() {
          return c.removeStyles(_, S);
        };
    }, [_, y, S, x, w]), null;
  }
  function p(y, S, w, x, _) {
    if (c.isStatic)
      c.renderStyles(y, Wo, w, _);
    else {
      var O = ze({}, S, { theme: Kr(S, x, d.defaultProps) });
      c.renderStyles(y, O, w, _);
    }
  }
  return process.env.NODE_ENV !== "production" && Xn(f), ke.memo(d);
}
function wa(r) {
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  for (var o = arguments.length, t = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
    t[a - 1] = arguments[a];
  var i = hr.apply(void 0, [r].concat(t)).join(""), f = Zr(i);
  return new Gn(f, i);
}
var Ea = function() {
  function r() {
    var t = this;
    this._emitSheetCSS = function() {
      var a = t.instance.toString();
      if (!a)
        return "";
      var i = Br();
      return "<style " + [i && 'nonce="' + i + '"', ft + '="true"', 'data-styled-version="5.3.11"'].filter(Boolean).join(" ") + ">" + a + "</style>";
    }, this.getStyleTags = function() {
      return t.sealed ? Ue(2) : t._emitSheetCSS();
    }, this.getStyleElement = function() {
      var a;
      if (t.sealed)
        return Ue(2);
      var i = ((a = {})[ft] = "", a["data-styled-version"] = "5.3.11", a.dangerouslySetInnerHTML = { __html: t.instance.toString() }, a), f = Br();
      return f && (i.nonce = f), [ke.createElement("style", ze({}, i, { key: "sc-0-0" }))];
    }, this.seal = function() {
      t.sealed = !0;
    }, this.instance = new Tt({ isServer: !0 }), this.sealed = !1;
  }
  var o = r.prototype;
  return o.collectStyles = function(t) {
    return this.sealed ? Ue(2) : ke.createElement(qn, { sheet: this.instance }, t);
  }, o.interleaveWithNodeStream = function(t) {
    return Ue(3);
  }, r;
}(), Ra = function(r) {
  var o = ke.forwardRef(function(t, a) {
    var i = St(pt), f = r.defaultProps, c = Kr(t, i, f);
    return process.env.NODE_ENV !== "production" && c === void 0 && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + $t(r) + '"'), ke.createElement(r, ze({}, t, { theme: c, ref: a }));
  });
  return Mn(o, r), o.displayName = "WithTheme(" + $t(r) + ")", o;
}, xa = function() {
  return St(pt);
}, Oa = { StyleSheet: Tt, masterSheet: Vn };
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const Ca = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ServerStyleSheet: Ea,
  StyleSheetConsumer: ca,
  StyleSheetContext: pr,
  StyleSheetManager: qn,
  ThemeConsumer: ya,
  ThemeContext: pt,
  ThemeProvider: va,
  __PRIVATE__: Oa,
  createGlobalStyle: Sa,
  css: hr,
  default: Wr,
  isStyledComponent: fr,
  keyframes: wa,
  useTheme: xa,
  version: zo,
  withTheme: Ra
}, Symbol.toStringTag, { value: "Module" })), Qr = /* @__PURE__ */ Ln(Ca);
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Rn = Object.getOwnPropertySymbols, Ta = Object.prototype.hasOwnProperty, Aa = Object.prototype.propertyIsEnumerable;
function _a(r) {
  if (r == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(r);
}
function Pa() {
  try {
    if (!Object.assign)
      return !1;
    var r = new String("abc");
    if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
      return !1;
    for (var o = {}, t = 0; t < 10; t++)
      o["_" + String.fromCharCode(t)] = t;
    var a = Object.getOwnPropertyNames(o).map(function(f) {
      return o[f];
    });
    if (a.join("") !== "0123456789")
      return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(f) {
      i[f] = f;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var ka = Pa() ? Object.assign : function(r, o) {
  for (var t, a = _a(r), i, f = 1; f < arguments.length; f++) {
    t = Object(arguments[f]);
    for (var c in t)
      Ta.call(t, c) && (a[c] = t[c]);
    if (Rn) {
      i = Rn(t);
      for (var d = 0; d < i.length; d++)
        Aa.call(t, i[d]) && (a[i[d]] = t[i[d]]);
    }
  }
  return a;
};
const et = /* @__PURE__ */ ur(ka);
var xn = function(o, t) {
  var a = et({}, o, t);
  for (var i in o) {
    var f;
    !o[i] || typeof t[i] != "object" || et(a, (f = {}, f[i] = et(o[i], t[i]), f));
  }
  return a;
}, Na = function(o) {
  var t = {};
  return Object.keys(o).sort(function(a, i) {
    return a.localeCompare(i, void 0, {
      numeric: !0,
      sensitivity: "base"
    });
  }).forEach(function(a) {
    t[a] = o[a];
  }), t;
}, ja = {
  breakpoints: [40, 52, 64].map(function(r) {
    return r + "em";
  })
}, Zn = function(o) {
  return "@media screen and (min-width: " + o + ")";
}, Ia = function(o, t) {
  return at(t, o, o);
}, at = function(o, t, a, i, f) {
  for (t = t && t.split ? t.split(".") : [t], i = 0; i < t.length; i++)
    o = o ? o[t[i]] : f;
  return o === f ? a : o;
}, Bt = function r(o) {
  var t = {}, a = function(c) {
    var d = {}, p = !1, y = c.theme && c.theme.disableStyledSystemCache;
    for (var S in c)
      if (o[S]) {
        var w = o[S], x = c[S], _ = at(c.theme, w.scale, w.defaults);
        if (typeof x == "object") {
          if (t.breakpoints = !y && t.breakpoints || at(c.theme, "breakpoints", ja.breakpoints), Array.isArray(x)) {
            t.media = !y && t.media || [null].concat(t.breakpoints.map(Zn)), d = xn(d, Da(t.media, w, _, x, c));
            continue;
          }
          x !== null && (d = xn(d, La(t.breakpoints, w, _, x, c)), p = !0);
          continue;
        }
        et(d, w(x, _, c));
      }
    return p && (d = Na(d)), d;
  };
  a.config = o, a.propNames = Object.keys(o), a.cache = t;
  var i = Object.keys(o).filter(function(f) {
    return f !== "config";
  });
  return i.length > 1 && i.forEach(function(f) {
    var c;
    a[f] = r((c = {}, c[f] = o[f], c));
  }), a;
}, Da = function(o, t, a, i, f) {
  var c = {};
  return i.slice(0, o.length).forEach(function(d, p) {
    var y = o[p], S = t(d, a, f);
    if (!y)
      et(c, S);
    else {
      var w;
      et(c, (w = {}, w[y] = et({}, c[y], S), w));
    }
  }), c;
}, La = function(o, t, a, i, f) {
  var c = {};
  for (var d in i) {
    var p = o[d], y = i[d], S = t(y, a, f);
    if (!p)
      et(c, S);
    else {
      var w, x = Zn(p);
      et(c, (w = {}, w[x] = et({}, c[x], S), w));
    }
  }
  return c;
}, lr = function(o) {
  var t = o.properties, a = o.property, i = o.scale, f = o.transform, c = f === void 0 ? Ia : f, d = o.defaultScale;
  t = t || [a];
  var p = function(S, w, x) {
    var _ = {}, O = c(S, w, x);
    if (O !== null)
      return t.forEach(function(I) {
        _[I] = O;
      }), _;
  };
  return p.scale = i, p.defaults = d, p;
}, Je = function(o) {
  o === void 0 && (o = {});
  var t = {};
  Object.keys(o).forEach(function(i) {
    var f = o[i];
    if (f === !0) {
      t[i] = lr({
        property: i,
        scale: i
      });
      return;
    }
    if (typeof f == "function") {
      t[i] = f;
      return;
    }
    t[i] = lr(f);
  });
  var a = Bt(t);
  return a;
}, Qn = function() {
  for (var o = {}, t = arguments.length, a = new Array(t), i = 0; i < t; i++)
    a[i] = arguments[i];
  a.forEach(function(c) {
    !c || !c.config || et(o, c.config);
  });
  var f = Bt(o);
  return f;
}, $a = function(o) {
  return typeof o == "number" && !isNaN(o);
}, Fa = function(o, t) {
  return at(t, o, !$a(o) || o > 1 ? o : o * 100 + "%");
}, Ba = {
  width: {
    property: "width",
    scale: "sizes",
    transform: Fa
  },
  height: {
    property: "height",
    scale: "sizes"
  },
  minWidth: {
    property: "minWidth",
    scale: "sizes"
  },
  minHeight: {
    property: "minHeight",
    scale: "sizes"
  },
  maxWidth: {
    property: "maxWidth",
    scale: "sizes"
  },
  maxHeight: {
    property: "maxHeight",
    scale: "sizes"
  },
  size: {
    properties: ["width", "height"],
    scale: "sizes"
  },
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  display: !0,
  verticalAlign: !0
}, We = Je(Ba), Hr = {
  color: {
    property: "color",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  opacity: !0
};
Hr.bg = Hr.backgroundColor;
var eo = Je(Hr), Ma = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
}, za = {
  fontFamily: {
    property: "fontFamily",
    scale: "fonts"
  },
  fontSize: {
    property: "fontSize",
    scale: "fontSizes",
    defaultScale: Ma.fontSizes
  },
  fontWeight: {
    property: "fontWeight",
    scale: "fontWeights"
  },
  lineHeight: {
    property: "lineHeight",
    scale: "lineHeights"
  },
  letterSpacing: {
    property: "letterSpacing",
    scale: "letterSpacings"
  },
  textAlign: !0,
  fontStyle: !0
}, ht = Je(za), Ua = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: !0,
  // item
  flex: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: !0,
  justifySelf: !0,
  alignSelf: !0,
  order: !0
}, Be = Je(Ua), Pr = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
}, Wa = {
  gridGap: {
    property: "gridGap",
    scale: "space",
    defaultScale: Pr.space
  },
  gridColumnGap: {
    property: "gridColumnGap",
    scale: "space",
    defaultScale: Pr.space
  },
  gridRowGap: {
    property: "gridRowGap",
    scale: "space",
    defaultScale: Pr.space
  },
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridAutoRows: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, He = Je(Wa), je = {
  border: {
    property: "border",
    scale: "borders"
  },
  borderWidth: {
    property: "borderWidth",
    scale: "borderWidths"
  },
  borderStyle: {
    property: "borderStyle",
    scale: "borderStyles"
  },
  borderColor: {
    property: "borderColor",
    scale: "colors"
  },
  borderRadius: {
    property: "borderRadius",
    scale: "radii"
  },
  borderTop: {
    property: "borderTop",
    scale: "borders"
  },
  borderTopLeftRadius: {
    property: "borderTopLeftRadius",
    scale: "radii"
  },
  borderTopRightRadius: {
    property: "borderTopRightRadius",
    scale: "radii"
  },
  borderRight: {
    property: "borderRight",
    scale: "borders"
  },
  borderBottom: {
    property: "borderBottom",
    scale: "borders"
  },
  borderBottomLeftRadius: {
    property: "borderBottomLeftRadius",
    scale: "radii"
  },
  borderBottomRightRadius: {
    property: "borderBottomRightRadius",
    scale: "radii"
  },
  borderLeft: {
    property: "borderLeft",
    scale: "borders"
  },
  borderX: {
    properties: ["borderLeft", "borderRight"],
    scale: "borders"
  },
  borderY: {
    properties: ["borderTop", "borderBottom"],
    scale: "borders"
  }
};
je.borderTopWidth = {
  property: "borderTopWidth",
  scale: "borderWidths"
};
je.borderTopColor = {
  property: "borderTopColor",
  scale: "colors"
};
je.borderTopStyle = {
  property: "borderTopStyle",
  scale: "borderStyles"
};
je.borderTopLeftRadius = {
  property: "borderTopLeftRadius",
  scale: "radii"
};
je.borderTopRightRadius = {
  property: "borderTopRightRadius",
  scale: "radii"
};
je.borderBottomWidth = {
  property: "borderBottomWidth",
  scale: "borderWidths"
};
je.borderBottomColor = {
  property: "borderBottomColor",
  scale: "colors"
};
je.borderBottomStyle = {
  property: "borderBottomStyle",
  scale: "borderStyles"
};
je.borderBottomLeftRadius = {
  property: "borderBottomLeftRadius",
  scale: "radii"
};
je.borderBottomRightRadius = {
  property: "borderBottomRightRadius",
  scale: "radii"
};
je.borderLeftWidth = {
  property: "borderLeftWidth",
  scale: "borderWidths"
};
je.borderLeftColor = {
  property: "borderLeftColor",
  scale: "colors"
};
je.borderLeftStyle = {
  property: "borderLeftStyle",
  scale: "borderStyles"
};
je.borderRightWidth = {
  property: "borderRightWidth",
  scale: "borderWidths"
};
je.borderRightColor = {
  property: "borderRightColor",
  scale: "colors"
};
je.borderRightStyle = {
  property: "borderRightStyle",
  scale: "borderStyles"
};
var rt = Je(je), it = {
  background: !0,
  backgroundImage: !0,
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0
};
it.bgImage = it.backgroundImage;
it.bgSize = it.backgroundSize;
it.bgPosition = it.backgroundPosition;
it.bgRepeat = it.backgroundRepeat;
var Mt = Je(it), or = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
}, Ha = {
  position: !0,
  zIndex: {
    property: "zIndex",
    scale: "zIndices"
  },
  top: {
    property: "top",
    scale: "space",
    defaultScale: or.space
  },
  right: {
    property: "right",
    scale: "space",
    defaultScale: or.space
  },
  bottom: {
    property: "bottom",
    scale: "space",
    defaultScale: or.space
  },
  left: {
    property: "left",
    scale: "space",
    defaultScale: or.space
  }
}, At = Je(Ha), Fe = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
}, On = function(o) {
  return typeof o == "number" && !isNaN(o);
}, yt = function(o, t) {
  if (!On(o))
    return at(t, o, o);
  var a = o < 0, i = Math.abs(o), f = at(t, i, i);
  return On(f) ? f * (a ? -1 : 1) : a ? "-" + f : f;
}, le = {};
le.margin = {
  margin: {
    property: "margin",
    scale: "space",
    transform: yt,
    defaultScale: Fe.space
  },
  marginTop: {
    property: "marginTop",
    scale: "space",
    transform: yt,
    defaultScale: Fe.space
  },
  marginRight: {
    property: "marginRight",
    scale: "space",
    transform: yt,
    defaultScale: Fe.space
  },
  marginBottom: {
    property: "marginBottom",
    scale: "space",
    transform: yt,
    defaultScale: Fe.space
  },
  marginLeft: {
    property: "marginLeft",
    scale: "space",
    transform: yt,
    defaultScale: Fe.space
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "space",
    transform: yt,
    defaultScale: Fe.space
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "space",
    transform: yt,
    defaultScale: Fe.space
  }
};
le.margin.m = le.margin.margin;
le.margin.mt = le.margin.marginTop;
le.margin.mr = le.margin.marginRight;
le.margin.mb = le.margin.marginBottom;
le.margin.ml = le.margin.marginLeft;
le.margin.mx = le.margin.marginX;
le.margin.my = le.margin.marginY;
le.padding = {
  padding: {
    property: "padding",
    scale: "space",
    defaultScale: Fe.space
  },
  paddingTop: {
    property: "paddingTop",
    scale: "space",
    defaultScale: Fe.space
  },
  paddingRight: {
    property: "paddingRight",
    scale: "space",
    defaultScale: Fe.space
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "space",
    defaultScale: Fe.space
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "space",
    defaultScale: Fe.space
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "space",
    defaultScale: Fe.space
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "space",
    defaultScale: Fe.space
  }
};
le.padding.p = le.padding.padding;
le.padding.pt = le.padding.paddingTop;
le.padding.pr = le.padding.paddingRight;
le.padding.pb = le.padding.paddingBottom;
le.padding.pl = le.padding.paddingLeft;
le.padding.px = le.padding.paddingX;
le.padding.py = le.padding.paddingY;
var to = Je(le.margin), ro = Je(le.padding), Va = Qn(to, ro), kr = Je({
  boxShadow: {
    property: "boxShadow",
    scale: "shadows"
  },
  textShadow: {
    property: "textShadow",
    scale: "shadows"
  }
});
function Ft() {
  return Ft = Object.assign || function(r) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (r[a] = t[a]);
    }
    return r;
  }, Ft.apply(this, arguments);
}
var tt = function(o, t, a, i, f) {
  for (t = t && t.split ? t.split(".") : [t], i = 0; i < t.length; i++)
    o = o ? o[t[i]] : f;
  return o === f ? a : o;
}, Ya = [40, 52, 64].map(function(r) {
  return r + "em";
}), qa = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
}, Ga = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
}, Cn = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
}, Xa = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
}, Ja = function(o, t) {
  if (typeof t != "number" || t >= 0)
    return tt(o, t, t);
  var a = Math.abs(t), i = tt(o, a, a);
  return typeof i == "string" ? "-" + i : i * -1;
}, Ka = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function(r, o) {
  var t;
  return Ft({}, r, (t = {}, t[o] = Ja, t));
}, {}), Za = function(o) {
  return function(t) {
    var a = {}, i = tt(t, "breakpoints", Ya), f = [null].concat(i.map(function(S) {
      return "@media screen and (min-width: " + S + ")";
    }));
    for (var c in o) {
      var d = typeof o[c] == "function" ? o[c](t) : o[c];
      if (d != null) {
        if (!Array.isArray(d)) {
          a[c] = d;
          continue;
        }
        for (var p = 0; p < d.slice(0, f.length).length; p++) {
          var y = f[p];
          if (!y) {
            a[c] = d[p];
            continue;
          }
          a[y] = a[y] || {}, d[p] != null && (a[y][c] = d[p]);
        }
      }
    }
    return a;
  };
}, Qa = function r(o) {
  return function(t) {
    t === void 0 && (t = {});
    var a = Ft({}, qa, {}, t.theme || t), i = {}, f = typeof o == "function" ? o(a) : o, c = Za(f)(a);
    for (var d in c) {
      var p = c[d], y = typeof p == "function" ? p(a) : p;
      if (d === "variant") {
        var S = r(tt(a, y))(a);
        i = Ft({}, i, {}, S);
        continue;
      }
      if (y && typeof y == "object") {
        i[d] = r(y)(a);
        continue;
      }
      var w = tt(Ga, d, d), x = tt(Xa, w), _ = tt(a, x, tt(a, w, {})), O = tt(Ka, w, tt), I = O(_, y, y);
      if (Cn[w])
        for (var j = Cn[w], D = 0; D < j.length; D++)
          i[j[D]] = I;
      else
        i[w] = I;
    }
    return i;
  };
};
const ei = Qa;
var mr = function(o) {
  var t, a = o.scale, i = o.prop, f = i === void 0 ? "variant" : i, c = o.variants, d = c === void 0 ? {} : c, p = o.key, y;
  Object.keys(d).length ? y = function(_, O, I) {
    return ei(at(O, _, null))(I.theme);
  } : y = function(_, O) {
    return at(O, _, null);
  }, y.scale = a || p, y.defaults = d;
  var S = (t = {}, t[f] = y, t), w = Bt(S);
  return w;
}, ti = mr({
  key: "buttons"
}), ri = mr({
  key: "textStyles",
  prop: "textStyle"
}), ni = mr({
  key: "colorStyles",
  prop: "colors"
}), oi = We.width, ai = We.height, ii = We.minWidth, si = We.minHeight, ci = We.maxWidth, li = We.maxHeight, ui = We.size, di = We.verticalAlign, fi = We.display, pi = We.overflow, hi = We.overflowX, mi = We.overflowY, gi = eo.opacity, yi = ht.fontSize, vi = ht.fontFamily, bi = ht.fontWeight, Si = ht.lineHeight, wi = ht.textAlign, Ei = ht.fontStyle, Ri = ht.letterSpacing, xi = Be.alignItems, Oi = Be.alignContent, Ci = Be.justifyItems, Ti = Be.justifyContent, Ai = Be.flexWrap, _i = Be.flexDirection, Pi = Be.flex, ki = Be.flexGrow, Ni = Be.flexShrink, ji = Be.flexBasis, Ii = Be.justifySelf, Di = Be.alignSelf, Li = Be.order, $i = He.gridGap, Fi = He.gridColumnGap, Bi = He.gridRowGap, Mi = He.gridColumn, zi = He.gridRow, Ui = He.gridAutoFlow, Wi = He.gridAutoColumns, Hi = He.gridAutoRows, Vi = He.gridTemplateColumns, Yi = He.gridTemplateRows, qi = He.gridTemplateAreas, Gi = He.gridArea, Xi = rt.borderWidth, Ji = rt.borderStyle, Ki = rt.borderColor, Zi = rt.borderTop, Qi = rt.borderRight, es = rt.borderBottom, ts = rt.borderLeft, rs = rt.borderRadius, ns = Mt.backgroundImage, os = Mt.backgroundSize, as = Mt.backgroundPosition, is = Mt.backgroundRepeat, ss = At.zIndex, cs = At.top, ls = At.right, us = At.bottom, ds = At.left, fs = function(o) {
  var t = o.prop, a = o.cssProperty, i = o.alias, f = o.key, c = o.transformValue, d = o.scale, p = o.properties, y = {};
  y[t] = lr({
    properties: p,
    property: a || t,
    scale: f,
    defaultScale: d,
    transform: c
  }), i && (y[i] = y[t]);
  var S = Bt(y);
  return S;
};
const ps = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alignContent: Oi,
  alignItems: xi,
  alignSelf: Di,
  background: Mt,
  backgroundImage: ns,
  backgroundPosition: as,
  backgroundRepeat: is,
  backgroundSize: os,
  border: rt,
  borderBottom: es,
  borderColor: Ki,
  borderLeft: ts,
  borderRadius: rs,
  borderRight: Qi,
  borderStyle: Ji,
  borderTop: Zi,
  borderWidth: Xi,
  borders: rt,
  bottom: us,
  boxShadow: kr,
  buttonStyle: ti,
  color: eo,
  colorStyle: ni,
  compose: Qn,
  createParser: Bt,
  createStyleFunction: lr,
  display: fi,
  flex: Pi,
  flexBasis: ji,
  flexDirection: _i,
  flexGrow: ki,
  flexShrink: Ni,
  flexWrap: Ai,
  flexbox: Be,
  fontFamily: vi,
  fontSize: yi,
  fontStyle: Ei,
  fontWeight: bi,
  get: at,
  grid: He,
  gridArea: Gi,
  gridAutoColumns: Wi,
  gridAutoFlow: Ui,
  gridAutoRows: Hi,
  gridColumn: Mi,
  gridColumnGap: Fi,
  gridGap: $i,
  gridRow: zi,
  gridRowGap: Bi,
  gridTemplateAreas: qi,
  gridTemplateColumns: Vi,
  gridTemplateRows: Yi,
  height: ai,
  justifyContent: Ti,
  justifyItems: Ci,
  justifySelf: Ii,
  layout: We,
  left: ds,
  letterSpacing: Ri,
  lineHeight: Si,
  margin: to,
  maxHeight: li,
  maxWidth: ci,
  minHeight: si,
  minWidth: ii,
  opacity: gi,
  order: Li,
  overflow: pi,
  overflowX: hi,
  overflowY: mi,
  padding: ro,
  position: At,
  right: ls,
  shadow: kr,
  size: ui,
  space: Va,
  style: fs,
  system: Je,
  textAlign: wi,
  textShadow: kr,
  textStyle: ri,
  top: cs,
  typography: ht,
  variant: mr,
  verticalAlign: di,
  width: oi,
  zIndex: ss
}, Symbol.toStringTag, { value: "Module" })), no = /* @__PURE__ */ Ln(ps);
var Nr = { exports: {} }, Tn;
function hs() {
  return Tn || (Tn = 1, function(r, o) {
    (function(t, a) {
      r.exports = a();
    })(self, () => (() => {
      var t = { 661: (c, d, p) => {
        p.d(d, { Circle: () => x, LoadingIndicatorBase: () => _ });
        const y = Qr;
        var S = p.n(y);
        const w = y.keyframes`
  0%,
  50%,
  100% {
    -webkit-transform: scale(0);
  }

  50% {
    -webkit-transform: scale(1);
  }
`, x = S().div`
  display: flex;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: var(--color-primary);

  :nth-child(n + 2){
    margin-left: 2px;
  }

  & {
    animation: ${w} 1.4s ease-in-out both infinite;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`, _ = S().div`
  display: inline-flex;

  ${({ size: O }) => O === "small" ? y.css`
        & > ${x} {
          width: 16px;
          height: 16px;
        }
      ` : O === "large" ? y.css`
        & > ${x} {
          width: 32px;
          height: 32px;
        }
      ` : y.css``}

  ${({ color: O }) => O && y.css`
    & > ${x} {
      background: var(--color-${O});
    }
  `}
`;
      } }, a = {};
      function i(c) {
        var d = a[c];
        if (d !== void 0)
          return d.exports;
        var p = a[c] = { exports: {} };
        return t[c](p, p.exports, i), p.exports;
      }
      i.n = (c) => {
        var d = c && c.__esModule ? () => c.default : () => c;
        return i.d(d, { a: d }), d;
      }, i.d = (c, d) => {
        for (var p in d)
          i.o(d, p) && !i.o(c, p) && Object.defineProperty(c, p, { enumerable: !0, get: d[p] });
      }, i.o = (c, d) => Object.prototype.hasOwnProperty.call(c, d), i.r = (c) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(c, "__esModule", { value: !0 });
      };
      var f = {};
      return (() => {
        i.r(f), i.d(f, { LoadingIndicator: () => S, default: () => w });
        const c = ke;
        var d = i.n(c), p = i(661), y = function(x, _) {
          var O = {};
          for (var I in x)
            Object.prototype.hasOwnProperty.call(x, I) && _.indexOf(I) < 0 && (O[I] = x[I]);
          if (x != null && typeof Object.getOwnPropertySymbols == "function") {
            var j = 0;
            for (I = Object.getOwnPropertySymbols(x); j < I.length; j++)
              _.indexOf(I[j]) < 0 && Object.prototype.propertyIsEnumerable.call(x, I[j]) && (O[I[j]] = x[I[j]]);
          }
          return O;
        };
        function S(x) {
          var { size: _ = "medium", color: O = "primary" } = x, I = y(x, ["size", "color"]);
          return d().createElement(p.LoadingIndicatorBase, Object.assign({ "aria-label": "Loading", role: "status", size: _, color: O }, I), d().createElement(p.Circle, null), d().createElement(p.Circle, null), d().createElement(p.Circle, null));
        }
        const w = S;
      })(), f;
    })());
  }(Nr)), Nr.exports;
}
var jr = { exports: {} }, Ir, An;
function ms() {
  if (An)
    return Ir;
  An = 1;
  function r(e, n) {
    return function() {
      return e.apply(n, arguments);
    };
  }
  const { toString: o } = Object.prototype, { getPrototypeOf: t } = Object, a = ((e) => (n) => {
    const s = o.call(n);
    return e[s] || (e[s] = s.slice(8, -1).toLowerCase());
  })(/* @__PURE__ */ Object.create(null)), i = (e) => (e = e.toLowerCase(), (n) => a(n) === e), f = (e) => (n) => typeof n === e, { isArray: c } = Array, d = f("undefined");
  function p(e) {
    return e !== null && !d(e) && e.constructor !== null && !d(e.constructor) && x(e.constructor.isBuffer) && e.constructor.isBuffer(e);
  }
  const y = i("ArrayBuffer");
  function S(e) {
    let n;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && y(e.buffer), n;
  }
  const w = f("string"), x = f("function"), _ = f("number"), O = (e) => e !== null && typeof e == "object", I = (e) => e === !0 || e === !1, j = (e) => {
    if (a(e) !== "object")
      return !1;
    const n = t(e);
    return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
  }, D = i("Date"), k = i("File"), L = i("Blob"), $ = i("FileList"), E = (e) => O(e) && x(e.pipe), z = (e) => {
    let n;
    return e && (typeof FormData == "function" && e instanceof FormData || x(e.append) && ((n = a(e)) === "formdata" || // detect form-data instance
    n === "object" && x(e.toString) && e.toString() === "[object FormData]"));
  }, oe = i("URLSearchParams"), Ee = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  function ue(e, n, { allOwnKeys: s = !1 } = {}) {
    if (e === null || typeof e > "u")
      return;
    let l, h;
    if (typeof e != "object" && (e = [e]), c(e))
      for (l = 0, h = e.length; l < h; l++)
        n.call(null, e[l], l, e);
    else {
      const g = s ? Object.getOwnPropertyNames(e) : Object.keys(e), b = g.length;
      let P;
      for (l = 0; l < b; l++)
        P = g[l], n.call(null, e[P], P, e);
    }
  }
  function Oe(e, n) {
    n = n.toLowerCase();
    const s = Object.keys(e);
    let l = s.length, h;
    for (; l-- > 0; )
      if (h = s[l], n === h.toLowerCase())
        return h;
    return null;
  }
  const Ae = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : bo)(), K = (e) => !d(e) && e !== Ae;
  function J() {
    const { caseless: e } = K(this) && this || {}, n = {}, s = (l, h) => {
      const g = e && Oe(n, h) || h;
      j(n[g]) && j(l) ? n[g] = J(n[g], l) : j(l) ? n[g] = J({}, l) : c(l) ? n[g] = l.slice() : n[g] = l;
    };
    for (let l = 0, h = arguments.length; l < h; l++)
      arguments[l] && ue(arguments[l], s);
    return n;
  }
  const Z = (e, n, s, { allOwnKeys: l } = {}) => (ue(n, (h, g) => {
    s && x(h) ? e[g] = r(h, s) : e[g] = h;
  }, { allOwnKeys: l }), e), ye = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ie = (e, n, s, l) => {
    e.prototype = Object.create(n.prototype, l), e.prototype.constructor = e, Object.defineProperty(e, "super", {
      value: n.prototype
    }), s && Object.assign(e.prototype, s);
  }, he = (e, n, s, l) => {
    let h, g, b;
    const P = {};
    if (n = n || {}, e == null)
      return n;
    do {
      for (h = Object.getOwnPropertyNames(e), g = h.length; g-- > 0; )
        b = h[g], (!l || l(b, e, n)) && !P[b] && (n[b] = e[b], P[b] = !0);
      e = s !== !1 && t(e);
    } while (e && (!s || s(e, n)) && e !== Object.prototype);
    return n;
  }, ve = (e, n, s) => {
    e = String(e), (s === void 0 || s > e.length) && (s = e.length), s -= n.length;
    const l = e.indexOf(n, s);
    return l !== -1 && l === s;
  }, Ve = (e) => {
    if (!e)
      return null;
    if (c(e))
      return e;
    let n = e.length;
    if (!_(n))
      return null;
    const s = new Array(n);
    for (; n-- > 0; )
      s[n] = e[n];
    return s;
  }, Le = ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && t(Uint8Array)), Ye = (e, n) => {
    const l = (e && e[Symbol.iterator]).call(e);
    let h;
    for (; (h = l.next()) && !h.done; ) {
      const g = h.value;
      n.call(e, g[0], g[1]);
    }
  }, M = (e, n) => {
    let s;
    const l = [];
    for (; (s = e.exec(n)) !== null; )
      l.push(s);
    return l;
  }, F = i("HTMLFormElement"), B = (e) => e.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function(s, l, h) {
      return l.toUpperCase() + h;
    }
  ), V = (({ hasOwnProperty: e }) => (n, s) => e.call(n, s))(Object.prototype), m = i("RegExp"), ee = (e, n) => {
    const s = Object.getOwnPropertyDescriptors(e), l = {};
    ue(s, (h, g) => {
      n(h, g, e) !== !1 && (l[g] = h);
    }), Object.defineProperties(e, l);
  }, T = (e) => {
    ee(e, (n, s) => {
      if (x(e) && ["arguments", "caller", "callee"].indexOf(s) !== -1)
        return !1;
      const l = e[s];
      if (x(l)) {
        if (n.enumerable = !1, "writable" in n) {
          n.writable = !1;
          return;
        }
        n.set || (n.set = () => {
          throw Error("Can not rewrite read-only method '" + s + "'");
        });
      }
    });
  }, de = (e, n) => {
    const s = {}, l = (h) => {
      h.forEach((g) => {
        s[g] = !0;
      });
    };
    return c(e) ? l(e) : l(String(e).split(n)), s;
  }, te = () => {
  }, ae = (e, n) => (e = +e, Number.isFinite(e) ? e : n), R = "abcdefghijklmnopqrstuvwxyz", be = "0123456789", Re = {
    DIGIT: be,
    ALPHA: R,
    ALPHA_DIGIT: R + R.toUpperCase() + be
  }, X = (e = 16, n = Re.ALPHA_DIGIT) => {
    let s = "";
    const { length: l } = n;
    for (; e--; )
      s += n[Math.random() * l | 0];
    return s;
  };
  function Ce(e) {
    return !!(e && x(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
  }
  const ie = (e) => {
    const n = new Array(10), s = (l, h) => {
      if (O(l)) {
        if (n.indexOf(l) >= 0)
          return;
        if (!("toJSON" in l)) {
          n[h] = l;
          const g = c(l) ? [] : {};
          return ue(l, (b, P) => {
            const G = s(b, h + 1);
            !d(G) && (g[P] = G);
          }), n[h] = void 0, g;
        }
      }
      return l;
    };
    return s(e, 0);
  }, Te = i("AsyncFunction");
  var v = {
    isArray: c,
    isArrayBuffer: y,
    isBuffer: p,
    isFormData: z,
    isArrayBufferView: S,
    isString: w,
    isNumber: _,
    isBoolean: I,
    isObject: O,
    isPlainObject: j,
    isUndefined: d,
    isDate: D,
    isFile: k,
    isBlob: L,
    isRegExp: m,
    isFunction: x,
    isStream: E,
    isURLSearchParams: oe,
    isTypedArray: Le,
    isFileList: $,
    forEach: ue,
    merge: J,
    extend: Z,
    trim: Ee,
    stripBOM: ye,
    inherits: Ie,
    toFlatObject: he,
    kindOf: a,
    kindOfTest: i,
    endsWith: ve,
    toArray: Ve,
    forEachEntry: Ye,
    matchAll: M,
    isHTMLForm: F,
    hasOwnProperty: V,
    hasOwnProp: V,
    // an alias to avoid ESLint no-prototype-builtins detection
    reduceDescriptors: ee,
    freezeMethods: T,
    toObjectSet: de,
    toCamelCase: B,
    noop: te,
    toFiniteNumber: ae,
    findKey: Oe,
    global: Ae,
    isContextDefined: K,
    ALPHABET: Re,
    generateString: X,
    isSpecCompliantForm: Ce,
    toJSONObject: ie,
    isAsyncFn: Te,
    isThenable: (e) => e && (O(e) || x(e)) && x(e.then) && x(e.catch)
  };
  function Q(e, n, s, l, h) {
    Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), s && (this.config = s), l && (this.request = l), h && (this.response = h);
  }
  v.inherits(Q, Error, {
    toJSON: function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: v.toJSONObject(this.config),
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    }
  });
  const qe = Q.prototype, De = {};
  [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
    // eslint-disable-next-line func-names
  ].forEach((e) => {
    De[e] = { value: e };
  }), Object.defineProperties(Q, De), Object.defineProperty(qe, "isAxiosError", { value: !0 }), Q.from = (e, n, s, l, h, g) => {
    const b = Object.create(qe);
    return v.toFlatObject(e, b, function(G) {
      return G !== Error.prototype;
    }, (P) => P !== "isAxiosError"), Q.call(b, e.message, n, s, l, h), b.cause = e, b.name = e.name, g && Object.assign(b, g), b;
  };
  var Y = null;
  function ge(e) {
    return v.isPlainObject(e) || v.isArray(e);
  }
  function nt(e) {
    return v.endsWith(e, "[]") ? e.slice(0, -2) : e;
  }
  function Ge(e, n, s) {
    return e ? e.concat(n).map(function(h, g) {
      return h = nt(h), !s && g ? "[" + h + "]" : h;
    }).join(s ? "." : "") : n;
  }
  function Xe(e) {
    return v.isArray(e) && !e.some(ge);
  }
  const zt = v.toFlatObject(v, {}, null, function(n) {
    return /^is[A-Z]/.test(n);
  });
  function mt(e, n, s) {
    if (!v.isObject(e))
      throw new TypeError("target must be an object");
    n = n || new FormData(), s = v.toFlatObject(s, {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    }, !1, function(se, ot) {
      return !v.isUndefined(ot[se]);
    });
    const l = s.metaTokens, h = s.visitor || U, g = s.dots, b = s.indexes, G = (s.Blob || typeof Blob < "u" && Blob) && v.isSpecCompliantForm(n);
    if (!v.isFunction(h))
      throw new TypeError("visitor must be a function");
    function A(W) {
      if (W === null)
        return "";
      if (v.isDate(W))
        return W.toISOString();
      if (!G && v.isBlob(W))
        throw new Q("Blob is not supported. Use a Buffer instead.");
      return v.isArrayBuffer(W) || v.isTypedArray(W) ? G && typeof Blob == "function" ? new Blob([W]) : Buffer.from(W) : W;
    }
    function U(W, se, ot) {
      let Qe = W;
      if (W && !ot && typeof W == "object") {
        if (v.endsWith(se, "{}"))
          se = l ? se : se.slice(0, -2), W = JSON.stringify(W);
        else if (v.isArray(W) && Xe(W) || (v.isFileList(W) || v.endsWith(se, "[]")) && (Qe = v.toArray(W)))
          return se = nt(se), Qe.forEach(function(er, mo) {
            !(v.isUndefined(er) || er === null) && n.append(
              // eslint-disable-next-line no-nested-ternary
              b === !0 ? Ge([se], mo, g) : b === null ? se : se + "[]",
              A(er)
            );
          }), !1;
      }
      return ge(W) ? !0 : (n.append(Ge(ot, se, g), A(W)), !1);
    }
    const ne = [], Ne = Object.assign(zt, {
      defaultVisitor: U,
      convertValue: A,
      isVisitable: ge
    });
    function we(W, se) {
      if (!v.isUndefined(W)) {
        if (ne.indexOf(W) !== -1)
          throw Error("Circular reference detected in " + se.join("."));
        ne.push(W), v.forEach(W, function(Qe, Ot) {
          (!(v.isUndefined(Qe) || Qe === null) && h.call(
            n,
            Qe,
            v.isString(Ot) ? Ot.trim() : Ot,
            se,
            Ne
          )) === !0 && we(Qe, se ? se.concat(Ot) : [Ot]);
        }), ne.pop();
      }
    }
    if (!v.isObject(e))
      throw new TypeError("data must be an object");
    return we(e), n;
  }
  function wt(e) {
    const n = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
      "%00": "\0"
    };
    return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(l) {
      return n[l];
    });
  }
  function _t(e, n) {
    this._pairs = [], e && mt(e, this, n);
  }
  const Ut = _t.prototype;
  Ut.append = function(n, s) {
    this._pairs.push([n, s]);
  }, Ut.toString = function(n) {
    const s = n ? function(l) {
      return n.call(this, l, wt);
    } : wt;
    return this._pairs.map(function(h) {
      return s(h[0]) + "=" + s(h[1]);
    }, "").join("&");
  };
  function gr(e) {
    return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  function Wt(e, n, s) {
    if (!n)
      return e;
    const l = s && s.encode || gr, h = s && s.serialize;
    let g;
    if (h ? g = h(n, s) : g = v.isURLSearchParams(n) ? n.toString() : new _t(n, s).toString(l), g) {
      const b = e.indexOf("#");
      b !== -1 && (e = e.slice(0, b)), e += (e.indexOf("?") === -1 ? "?" : "&") + g;
    }
    return e;
  }
  class yr {
    constructor() {
      this.handlers = [];
    }
    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     *
     * @return {Number} An ID used to remove interceptor later
     */
    use(n, s, l) {
      return this.handlers.push({
        fulfilled: n,
        rejected: s,
        synchronous: l ? l.synchronous : !1,
        runWhen: l ? l.runWhen : null
      }), this.handlers.length - 1;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
     */
    eject(n) {
      this.handlers[n] && (this.handlers[n] = null);
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
    clear() {
      this.handlers && (this.handlers = []);
    }
    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     *
     * @returns {void}
     */
    forEach(n) {
      v.forEach(this.handlers, function(l) {
        l !== null && n(l);
      });
    }
  }
  var Ht = yr, Vt = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  }, Pt = typeof URLSearchParams < "u" ? URLSearchParams : _t, Yt = typeof FormData < "u" ? FormData : null, st = typeof Blob < "u" ? Blob : null;
  const kt = (() => {
    let e;
    return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
  })(), Nt = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts == "function")();
  var Me = {
    isBrowser: !0,
    classes: {
      URLSearchParams: Pt,
      FormData: Yt,
      Blob: st
    },
    isStandardBrowserEnv: kt,
    isStandardBrowserWebWorkerEnv: Nt,
    protocols: ["http", "https", "file", "blob", "url", "data"]
  };
  function vr(e, n) {
    return mt(e, new Me.classes.URLSearchParams(), Object.assign({
      visitor: function(s, l, h, g) {
        return Me.isNode && v.isBuffer(s) ? (this.append(l, s.toString("base64")), !1) : g.defaultVisitor.apply(this, arguments);
      }
    }, n));
  }
  function qt(e) {
    return v.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
  }
  function br(e) {
    const n = {}, s = Object.keys(e);
    let l;
    const h = s.length;
    let g;
    for (l = 0; l < h; l++)
      g = s[l], n[g] = e[g];
    return n;
  }
  function jt(e) {
    function n(s, l, h, g) {
      let b = s[g++];
      const P = Number.isFinite(+b), G = g >= s.length;
      return b = !b && v.isArray(h) ? h.length : b, G ? (v.hasOwnProp(h, b) ? h[b] = [h[b], l] : h[b] = l, !P) : ((!h[b] || !v.isObject(h[b])) && (h[b] = []), n(s, l, h[b], g) && v.isArray(h[b]) && (h[b] = br(h[b])), !P);
    }
    if (v.isFormData(e) && v.isFunction(e.entries)) {
      const s = {};
      return v.forEachEntry(e, (l, h) => {
        n(qt(l), h, s, 0);
      }), s;
    }
    return null;
  }
  const Gt = {
    "Content-Type": void 0
  };
  function Sr(e, n, s) {
    if (v.isString(e))
      try {
        return (n || JSON.parse)(e), v.trim(e);
      } catch (l) {
        if (l.name !== "SyntaxError")
          throw l;
      }
    return (s || JSON.stringify)(e);
  }
  const Et = {
    transitional: Vt,
    adapter: ["xhr", "http"],
    transformRequest: [function(n, s) {
      const l = s.getContentType() || "", h = l.indexOf("application/json") > -1, g = v.isObject(n);
      if (g && v.isHTMLForm(n) && (n = new FormData(n)), v.isFormData(n))
        return h && h ? JSON.stringify(jt(n)) : n;
      if (v.isArrayBuffer(n) || v.isBuffer(n) || v.isStream(n) || v.isFile(n) || v.isBlob(n))
        return n;
      if (v.isArrayBufferView(n))
        return n.buffer;
      if (v.isURLSearchParams(n))
        return s.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let P;
      if (g) {
        if (l.indexOf("application/x-www-form-urlencoded") > -1)
          return vr(n, this.formSerializer).toString();
        if ((P = v.isFileList(n)) || l.indexOf("multipart/form-data") > -1) {
          const G = this.env && this.env.FormData;
          return mt(
            P ? { "files[]": n } : n,
            G && new G(),
            this.formSerializer
          );
        }
      }
      return g || h ? (s.setContentType("application/json", !1), Sr(n)) : n;
    }],
    transformResponse: [function(n) {
      const s = this.transitional || Et.transitional, l = s && s.forcedJSONParsing, h = this.responseType === "json";
      if (n && v.isString(n) && (l && !this.responseType || h)) {
        const b = !(s && s.silentJSONParsing) && h;
        try {
          return JSON.parse(n);
        } catch (P) {
          if (b)
            throw P.name === "SyntaxError" ? Q.from(P, Q.ERR_BAD_RESPONSE, this, null, this.response) : P;
        }
      }
      return n;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: Me.classes.FormData,
      Blob: Me.classes.Blob
    },
    validateStatus: function(n) {
      return n >= 200 && n < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  v.forEach(["delete", "get", "head"], function(n) {
    Et.headers[n] = {};
  }), v.forEach(["post", "put", "patch"], function(n) {
    Et.headers[n] = v.merge(Gt);
  });
  var Rt = Et;
  const wr = v.toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ]);
  var Er = (e) => {
    const n = {};
    let s, l, h;
    return e && e.split(`
`).forEach(function(b) {
      h = b.indexOf(":"), s = b.substring(0, h).trim().toLowerCase(), l = b.substring(h + 1).trim(), !(!s || n[s] && wr[s]) && (s === "set-cookie" ? n[s] ? n[s].push(l) : n[s] = [l] : n[s] = n[s] ? n[s] + ", " + l : l);
    }), n;
  };
  const Xt = Symbol("internals");
  function gt(e) {
    return e && String(e).trim().toLowerCase();
  }
  function u(e) {
    return e === !1 || e == null ? e : v.isArray(e) ? e.map(u) : String(e);
  }
  function C(e) {
    const n = /* @__PURE__ */ Object.create(null), s = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let l;
    for (; l = s.exec(e); )
      n[l[1]] = l[2];
    return n;
  }
  const N = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
  function H(e, n, s, l, h) {
    if (v.isFunction(l))
      return l.call(this, n, s);
    if (h && (n = s), !!v.isString(n)) {
      if (v.isString(l))
        return n.indexOf(l) !== -1;
      if (v.isRegExp(l))
        return l.test(n);
    }
  }
  function ce(e) {
    return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, s, l) => s.toUpperCase() + l);
  }
  function me(e, n) {
    const s = v.toCamelCase(" " + n);
    ["get", "set", "has"].forEach((l) => {
      Object.defineProperty(e, l + s, {
        value: function(h, g, b) {
          return this[l].call(this, n, h, g, b);
        },
        configurable: !0
      });
    });
  }
  class re {
    constructor(n) {
      n && this.set(n);
    }
    set(n, s, l) {
      const h = this;
      function g(P, G, A) {
        const U = gt(G);
        if (!U)
          throw new Error("header name must be a non-empty string");
        const ne = v.findKey(h, U);
        (!ne || h[ne] === void 0 || A === !0 || A === void 0 && h[ne] !== !1) && (h[ne || G] = u(P));
      }
      const b = (P, G) => v.forEach(P, (A, U) => g(A, U, G));
      return v.isPlainObject(n) || n instanceof this.constructor ? b(n, s) : v.isString(n) && (n = n.trim()) && !N(n) ? b(Er(n), s) : n != null && g(s, n, l), this;
    }
    get(n, s) {
      if (n = gt(n), n) {
        const l = v.findKey(this, n);
        if (l) {
          const h = this[l];
          if (!s)
            return h;
          if (s === !0)
            return C(h);
          if (v.isFunction(s))
            return s.call(this, h, l);
          if (v.isRegExp(s))
            return s.exec(h);
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
    has(n, s) {
      if (n = gt(n), n) {
        const l = v.findKey(this, n);
        return !!(l && this[l] !== void 0 && (!s || H(this, this[l], l, s)));
      }
      return !1;
    }
    delete(n, s) {
      const l = this;
      let h = !1;
      function g(b) {
        if (b = gt(b), b) {
          const P = v.findKey(l, b);
          P && (!s || H(l, l[P], P, s)) && (delete l[P], h = !0);
        }
      }
      return v.isArray(n) ? n.forEach(g) : g(n), h;
    }
    clear(n) {
      const s = Object.keys(this);
      let l = s.length, h = !1;
      for (; l--; ) {
        const g = s[l];
        (!n || H(this, this[g], g, n, !0)) && (delete this[g], h = !0);
      }
      return h;
    }
    normalize(n) {
      const s = this, l = {};
      return v.forEach(this, (h, g) => {
        const b = v.findKey(l, g);
        if (b) {
          s[b] = u(h), delete s[g];
          return;
        }
        const P = n ? ce(g) : String(g).trim();
        P !== g && delete s[g], s[P] = u(h), l[P] = !0;
      }), this;
    }
    concat(...n) {
      return this.constructor.concat(this, ...n);
    }
    toJSON(n) {
      const s = /* @__PURE__ */ Object.create(null);
      return v.forEach(this, (l, h) => {
        l != null && l !== !1 && (s[h] = n && v.isArray(l) ? l.join(", ") : l);
      }), s;
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([n, s]) => n + ": " + s).join(`
`);
    }
    get [Symbol.toStringTag]() {
      return "AxiosHeaders";
    }
    static from(n) {
      return n instanceof this ? n : new this(n);
    }
    static concat(n, ...s) {
      const l = new this(n);
      return s.forEach((h) => l.set(h)), l;
    }
    static accessor(n) {
      const l = (this[Xt] = this[Xt] = {
        accessors: {}
      }).accessors, h = this.prototype;
      function g(b) {
        const P = gt(b);
        l[P] || (me(h, b), l[P] = !0);
      }
      return v.isArray(n) ? n.forEach(g) : g(n), this;
    }
  }
  re.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), v.freezeMethods(re.prototype), v.freezeMethods(re);
  var q = re;
  function _e(e, n) {
    const s = this || Rt, l = n || s, h = q.from(l.headers);
    let g = l.data;
    return v.forEach(e, function(P) {
      g = P.call(s, g, h.normalize(), n ? n.status : void 0);
    }), h.normalize(), g;
  }
  function xe(e) {
    return !!(e && e.__CANCEL__);
  }
  function Se(e, n, s) {
    Q.call(this, e ?? "canceled", Q.ERR_CANCELED, n, s), this.name = "CanceledError";
  }
  v.inherits(Se, Q, {
    __CANCEL__: !0
  });
  function $e(e, n, s) {
    const l = s.config.validateStatus;
    !s.status || !l || l(s.status) ? e(s) : n(new Q(
      "Request failed with status code " + s.status,
      [Q.ERR_BAD_REQUEST, Q.ERR_BAD_RESPONSE][Math.floor(s.status / 100) - 4],
      s.config,
      s.request,
      s
    ));
  }
  var ct = Me.isStandardBrowserEnv ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(s, l, h, g, b, P) {
          const G = [];
          G.push(s + "=" + encodeURIComponent(l)), v.isNumber(h) && G.push("expires=" + new Date(h).toGMTString()), v.isString(g) && G.push("path=" + g), v.isString(b) && G.push("domain=" + b), P === !0 && G.push("secure"), document.cookie = G.join("; ");
        },
        read: function(s) {
          const l = document.cookie.match(new RegExp("(^|;\\s*)(" + s + ")=([^;]*)"));
          return l ? decodeURIComponent(l[3]) : null;
        },
        remove: function(s) {
          this.write(s, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  );
  function Jt(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  }
  function Ze(e, n) {
    return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e;
  }
  function en(e, n) {
    return e && !Jt(n) ? Ze(e, n) : n;
  }
  var oo = Me.isStandardBrowserEnv ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      const n = /(msie|trident)/i.test(navigator.userAgent), s = document.createElement("a");
      let l;
      function h(g) {
        let b = g;
        return n && (s.setAttribute("href", b), b = s.href), s.setAttribute("href", b), {
          href: s.href,
          protocol: s.protocol ? s.protocol.replace(/:$/, "") : "",
          host: s.host,
          search: s.search ? s.search.replace(/^\?/, "") : "",
          hash: s.hash ? s.hash.replace(/^#/, "") : "",
          hostname: s.hostname,
          port: s.port,
          pathname: s.pathname.charAt(0) === "/" ? s.pathname : "/" + s.pathname
        };
      }
      return l = h(window.location.href), function(b) {
        const P = v.isString(b) ? h(b) : b;
        return P.protocol === l.protocol && P.host === l.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  );
  function ao(e) {
    const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return n && n[1] || "";
  }
  function io(e, n) {
    e = e || 10;
    const s = new Array(e), l = new Array(e);
    let h = 0, g = 0, b;
    return n = n !== void 0 ? n : 1e3, function(G) {
      const A = Date.now(), U = l[g];
      b || (b = A), s[h] = G, l[h] = A;
      let ne = g, Ne = 0;
      for (; ne !== h; )
        Ne += s[ne++], ne = ne % e;
      if (h = (h + 1) % e, h === g && (g = (g + 1) % e), A - b < n)
        return;
      const we = U && A - U;
      return we ? Math.round(Ne * 1e3 / we) : void 0;
    };
  }
  function tn(e, n) {
    let s = 0;
    const l = io(50, 250);
    return (h) => {
      const g = h.loaded, b = h.lengthComputable ? h.total : void 0, P = g - s, G = l(P), A = g <= b;
      s = g;
      const U = {
        loaded: g,
        total: b,
        progress: b ? g / b : void 0,
        bytes: P,
        rate: G || void 0,
        estimated: G && b && A ? (b - g) / G : void 0,
        event: h
      };
      U[n ? "download" : "upload"] = !0, e(U);
    };
  }
  var so = typeof XMLHttpRequest < "u" && function(e) {
    return new Promise(function(s, l) {
      let h = e.data;
      const g = q.from(e.headers).normalize(), b = e.responseType;
      let P;
      function G() {
        e.cancelToken && e.cancelToken.unsubscribe(P), e.signal && e.signal.removeEventListener("abort", P);
      }
      v.isFormData(h) && (Me.isStandardBrowserEnv || Me.isStandardBrowserWebWorkerEnv ? g.setContentType(!1) : g.setContentType("multipart/form-data;", !1));
      let A = new XMLHttpRequest();
      if (e.auth) {
        const we = e.auth.username || "", W = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
        g.set("Authorization", "Basic " + btoa(we + ":" + W));
      }
      const U = en(e.baseURL, e.url);
      A.open(e.method.toUpperCase(), Wt(U, e.params, e.paramsSerializer), !0), A.timeout = e.timeout;
      function ne() {
        if (!A)
          return;
        const we = q.from(
          "getAllResponseHeaders" in A && A.getAllResponseHeaders()
        ), se = {
          data: !b || b === "text" || b === "json" ? A.responseText : A.response,
          status: A.status,
          statusText: A.statusText,
          headers: we,
          config: e,
          request: A
        };
        $e(function(Qe) {
          s(Qe), G();
        }, function(Qe) {
          l(Qe), G();
        }, se), A = null;
      }
      if ("onloadend" in A ? A.onloadend = ne : A.onreadystatechange = function() {
        !A || A.readyState !== 4 || A.status === 0 && !(A.responseURL && A.responseURL.indexOf("file:") === 0) || setTimeout(ne);
      }, A.onabort = function() {
        A && (l(new Q("Request aborted", Q.ECONNABORTED, e, A)), A = null);
      }, A.onerror = function() {
        l(new Q("Network Error", Q.ERR_NETWORK, e, A)), A = null;
      }, A.ontimeout = function() {
        let W = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
        const se = e.transitional || Vt;
        e.timeoutErrorMessage && (W = e.timeoutErrorMessage), l(new Q(
          W,
          se.clarifyTimeoutError ? Q.ETIMEDOUT : Q.ECONNABORTED,
          e,
          A
        )), A = null;
      }, Me.isStandardBrowserEnv) {
        const we = (e.withCredentials || oo(U)) && e.xsrfCookieName && ct.read(e.xsrfCookieName);
        we && g.set(e.xsrfHeaderName, we);
      }
      h === void 0 && g.setContentType(null), "setRequestHeader" in A && v.forEach(g.toJSON(), function(W, se) {
        A.setRequestHeader(se, W);
      }), v.isUndefined(e.withCredentials) || (A.withCredentials = !!e.withCredentials), b && b !== "json" && (A.responseType = e.responseType), typeof e.onDownloadProgress == "function" && A.addEventListener("progress", tn(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && A.upload && A.upload.addEventListener("progress", tn(e.onUploadProgress)), (e.cancelToken || e.signal) && (P = (we) => {
        A && (l(!we || we.type ? new Se(null, e, A) : we), A.abort(), A = null);
      }, e.cancelToken && e.cancelToken.subscribe(P), e.signal && (e.signal.aborted ? P() : e.signal.addEventListener("abort", P)));
      const Ne = ao(U);
      if (Ne && Me.protocols.indexOf(Ne) === -1) {
        l(new Q("Unsupported protocol " + Ne + ":", Q.ERR_BAD_REQUEST, e));
        return;
      }
      A.send(h || null);
    });
  };
  const Kt = {
    http: Y,
    xhr: so
  };
  v.forEach(Kt, (e, n) => {
    if (e) {
      try {
        Object.defineProperty(e, "name", { value: n });
      } catch {
      }
      Object.defineProperty(e, "adapterName", { value: n });
    }
  });
  var co = {
    getAdapter: (e) => {
      e = v.isArray(e) ? e : [e];
      const { length: n } = e;
      let s, l;
      for (let h = 0; h < n && (s = e[h], !(l = v.isString(s) ? Kt[s.toLowerCase()] : s)); h++)
        ;
      if (!l)
        throw l === !1 ? new Q(
          `Adapter ${s} is not supported by the environment`,
          "ERR_NOT_SUPPORT"
        ) : new Error(
          v.hasOwnProp(Kt, s) ? `Adapter '${s}' is not available in the build` : `Unknown adapter '${s}'`
        );
      if (!v.isFunction(l))
        throw new TypeError("adapter is not a function");
      return l;
    },
    adapters: Kt
  };
  function Rr(e) {
    if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
      throw new Se(null, e);
  }
  function rn(e) {
    return Rr(e), e.headers = q.from(e.headers), e.data = _e.call(
      e,
      e.transformRequest
    ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), co.getAdapter(e.adapter || Rt.adapter)(e).then(function(l) {
      return Rr(e), l.data = _e.call(
        e,
        e.transformResponse,
        l
      ), l.headers = q.from(l.headers), l;
    }, function(l) {
      return xe(l) || (Rr(e), l && l.response && (l.response.data = _e.call(
        e,
        e.transformResponse,
        l.response
      ), l.response.headers = q.from(l.response.headers))), Promise.reject(l);
    });
  }
  const nn = (e) => e instanceof q ? e.toJSON() : e;
  function xt(e, n) {
    n = n || {};
    const s = {};
    function l(A, U, ne) {
      return v.isPlainObject(A) && v.isPlainObject(U) ? v.merge.call({ caseless: ne }, A, U) : v.isPlainObject(U) ? v.merge({}, U) : v.isArray(U) ? U.slice() : U;
    }
    function h(A, U, ne) {
      if (v.isUndefined(U)) {
        if (!v.isUndefined(A))
          return l(void 0, A, ne);
      } else
        return l(A, U, ne);
    }
    function g(A, U) {
      if (!v.isUndefined(U))
        return l(void 0, U);
    }
    function b(A, U) {
      if (v.isUndefined(U)) {
        if (!v.isUndefined(A))
          return l(void 0, A);
      } else
        return l(void 0, U);
    }
    function P(A, U, ne) {
      if (ne in n)
        return l(A, U);
      if (ne in e)
        return l(void 0, A);
    }
    const G = {
      url: g,
      method: g,
      data: g,
      baseURL: b,
      transformRequest: b,
      transformResponse: b,
      paramsSerializer: b,
      timeout: b,
      timeoutMessage: b,
      withCredentials: b,
      adapter: b,
      responseType: b,
      xsrfCookieName: b,
      xsrfHeaderName: b,
      onUploadProgress: b,
      onDownloadProgress: b,
      decompress: b,
      maxContentLength: b,
      maxBodyLength: b,
      beforeRedirect: b,
      transport: b,
      httpAgent: b,
      httpsAgent: b,
      cancelToken: b,
      socketPath: b,
      responseEncoding: b,
      validateStatus: P,
      headers: (A, U) => h(nn(A), nn(U), !0)
    };
    return v.forEach(Object.keys(Object.assign({}, e, n)), function(U) {
      const ne = G[U] || h, Ne = ne(e[U], n[U], U);
      v.isUndefined(Ne) && ne !== P || (s[U] = Ne);
    }), s;
  }
  const on = "1.4.0", xr = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
    xr[e] = function(l) {
      return typeof l === e || "a" + (n < 1 ? "n " : " ") + e;
    };
  });
  const an = {};
  xr.transitional = function(n, s, l) {
    function h(g, b) {
      return "[Axios v" + on + "] Transitional option '" + g + "'" + b + (l ? ". " + l : "");
    }
    return (g, b, P) => {
      if (n === !1)
        throw new Q(
          h(b, " has been removed" + (s ? " in " + s : "")),
          Q.ERR_DEPRECATED
        );
      return s && !an[b] && (an[b] = !0, console.warn(
        h(
          b,
          " has been deprecated since v" + s + " and will be removed in the near future"
        )
      )), n ? n(g, b, P) : !0;
    };
  };
  function lo(e, n, s) {
    if (typeof e != "object")
      throw new Q("options must be an object", Q.ERR_BAD_OPTION_VALUE);
    const l = Object.keys(e);
    let h = l.length;
    for (; h-- > 0; ) {
      const g = l[h], b = n[g];
      if (b) {
        const P = e[g], G = P === void 0 || b(P, g, e);
        if (G !== !0)
          throw new Q("option " + g + " must be " + G, Q.ERR_BAD_OPTION_VALUE);
        continue;
      }
      if (s !== !0)
        throw new Q("Unknown option " + g, Q.ERR_BAD_OPTION);
    }
  }
  var Or = {
    assertOptions: lo,
    validators: xr
  };
  const lt = Or.validators;
  class Zt {
    constructor(n) {
      this.defaults = n, this.interceptors = {
        request: new Ht(),
        response: new Ht()
      };
    }
    /**
     * Dispatch a request
     *
     * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
     * @param {?Object} config
     *
     * @returns {Promise} The Promise to be fulfilled
     */
    request(n, s) {
      typeof n == "string" ? (s = s || {}, s.url = n) : s = n || {}, s = xt(this.defaults, s);
      const { transitional: l, paramsSerializer: h, headers: g } = s;
      l !== void 0 && Or.assertOptions(l, {
        silentJSONParsing: lt.transitional(lt.boolean),
        forcedJSONParsing: lt.transitional(lt.boolean),
        clarifyTimeoutError: lt.transitional(lt.boolean)
      }, !1), h != null && (v.isFunction(h) ? s.paramsSerializer = {
        serialize: h
      } : Or.assertOptions(h, {
        encode: lt.function,
        serialize: lt.function
      }, !0)), s.method = (s.method || this.defaults.method || "get").toLowerCase();
      let b;
      b = g && v.merge(
        g.common,
        g[s.method]
      ), b && v.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        (W) => {
          delete g[W];
        }
      ), s.headers = q.concat(b, g);
      const P = [];
      let G = !0;
      this.interceptors.request.forEach(function(se) {
        typeof se.runWhen == "function" && se.runWhen(s) === !1 || (G = G && se.synchronous, P.unshift(se.fulfilled, se.rejected));
      });
      const A = [];
      this.interceptors.response.forEach(function(se) {
        A.push(se.fulfilled, se.rejected);
      });
      let U, ne = 0, Ne;
      if (!G) {
        const W = [rn.bind(this), void 0];
        for (W.unshift.apply(W, P), W.push.apply(W, A), Ne = W.length, U = Promise.resolve(s); ne < Ne; )
          U = U.then(W[ne++], W[ne++]);
        return U;
      }
      Ne = P.length;
      let we = s;
      for (ne = 0; ne < Ne; ) {
        const W = P[ne++], se = P[ne++];
        try {
          we = W(we);
        } catch (ot) {
          se.call(this, ot);
          break;
        }
      }
      try {
        U = rn.call(this, we);
      } catch (W) {
        return Promise.reject(W);
      }
      for (ne = 0, Ne = A.length; ne < Ne; )
        U = U.then(A[ne++], A[ne++]);
      return U;
    }
    getUri(n) {
      n = xt(this.defaults, n);
      const s = en(n.baseURL, n.url);
      return Wt(s, n.params, n.paramsSerializer);
    }
  }
  v.forEach(["delete", "get", "head", "options"], function(n) {
    Zt.prototype[n] = function(s, l) {
      return this.request(xt(l || {}, {
        method: n,
        url: s,
        data: (l || {}).data
      }));
    };
  }), v.forEach(["post", "put", "patch"], function(n) {
    function s(l) {
      return function(g, b, P) {
        return this.request(xt(P || {}, {
          method: n,
          headers: l ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: g,
          data: b
        }));
      };
    }
    Zt.prototype[n] = s(), Zt.prototype[n + "Form"] = s(!0);
  });
  var Qt = Zt;
  class Cr {
    constructor(n) {
      if (typeof n != "function")
        throw new TypeError("executor must be a function.");
      let s;
      this.promise = new Promise(function(g) {
        s = g;
      });
      const l = this;
      this.promise.then((h) => {
        if (!l._listeners)
          return;
        let g = l._listeners.length;
        for (; g-- > 0; )
          l._listeners[g](h);
        l._listeners = null;
      }), this.promise.then = (h) => {
        let g;
        const b = new Promise((P) => {
          l.subscribe(P), g = P;
        }).then(h);
        return b.cancel = function() {
          l.unsubscribe(g);
        }, b;
      }, n(function(g, b, P) {
        l.reason || (l.reason = new Se(g, b, P), s(l.reason));
      });
    }
    /**
     * Throws a `CanceledError` if cancellation has been requested.
     */
    throwIfRequested() {
      if (this.reason)
        throw this.reason;
    }
    /**
     * Subscribe to the cancel signal
     */
    subscribe(n) {
      if (this.reason) {
        n(this.reason);
        return;
      }
      this._listeners ? this._listeners.push(n) : this._listeners = [n];
    }
    /**
     * Unsubscribe from the cancel signal
     */
    unsubscribe(n) {
      if (!this._listeners)
        return;
      const s = this._listeners.indexOf(n);
      s !== -1 && this._listeners.splice(s, 1);
    }
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */
    static source() {
      let n;
      return {
        token: new Cr(function(h) {
          n = h;
        }),
        cancel: n
      };
    }
  }
  var uo = Cr;
  function fo(e) {
    return function(s) {
      return e.apply(null, s);
    };
  }
  function po(e) {
    return v.isObject(e) && e.isAxiosError === !0;
  }
  const Tr = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
  };
  Object.entries(Tr).forEach(([e, n]) => {
    Tr[n] = e;
  });
  var ho = Tr;
  function sn(e) {
    const n = new Qt(e), s = r(Qt.prototype.request, n);
    return v.extend(s, Qt.prototype, n, { allOwnKeys: !0 }), v.extend(s, n, null, { allOwnKeys: !0 }), s.create = function(h) {
      return sn(xt(e, h));
    }, s;
  }
  const Pe = sn(Rt);
  return Pe.Axios = Qt, Pe.CanceledError = Se, Pe.CancelToken = uo, Pe.isCancel = xe, Pe.VERSION = on, Pe.toFormData = mt, Pe.AxiosError = Q, Pe.Cancel = Pe.CanceledError, Pe.all = function(n) {
    return Promise.all(n);
  }, Pe.spread = fo, Pe.isAxiosError = po, Pe.mergeConfig = xt, Pe.AxiosHeaders = q, Pe.formToJSON = (e) => jt(v.isHTMLForm(e) ? new FormData(e) : e), Pe.HttpStatusCode = ho, Pe.default = Pe, Ir = Pe, Ir;
}
var _n;
function gs() {
  return _n || (_n = 1, function(r, o) {
    (function(t, a) {
      r.exports = a();
    })(self, () => (() => {
      var t = { 380: (c, d, p) => {
        p.d(d, { Icon: () => D, IconBase: () => k });
        var y = p(689), S = p.n(y), w = p(518), x = p.n(w), _ = p(167), O = p.n(_), I = p(834), j = function(L, $) {
          var E = {};
          for (var z in L)
            Object.prototype.hasOwnProperty.call(L, z) && $.indexOf(z) < 0 && (E[z] = L[z]);
          if (L != null && typeof Object.getOwnPropertySymbols == "function") {
            var oe = 0;
            for (z = Object.getOwnPropertySymbols(L); oe < z.length; oe++)
              $.indexOf(z[oe]) < 0 && Object.prototype.propertyIsEnumerable.call(L, z[oe]) && (E[z[oe]] = L[z[oe]]);
          }
          return E;
        };
        function D(L) {
          var { name: $, className: E = "" } = L, z = j(L, ["name", "className"]);
          const oe = !!(z.title || z["aria-label"] || z["aria-labelledby"]), [Ee, ue] = (0, y.useState)(""), Oe = (0, y.useMemo)(() => {
            var K, J;
            return !((J = (K = window == null ? void 0 : window.env) === null || K === void 0 ? void 0 : K.ASSETS) === null || J === void 0) && J.includes("assets-t") ? "https://assets-t.storebrand.no/icons/" : "https://assets.storebrand.no/icons/";
          }, []), Ae = `icon icon-${$} ${E}`;
          return (0, y.useEffect)(() => {
            const K = O().CancelToken.source(), { href: J } = new URL(`${$}.svg`, Oe);
            return O().get(J, { cancelToken: K.token }).then((Z) => ue(Z.data)).catch((Z) => {
              O().isCancel(Z) || ue(`Can't find an icon with name ${$}!`);
            }), () => K.cancel("Canceling in cleanup!");
          }, [$, Oe]), S().createElement(k, Object.assign({ className: Ae, dangerouslySetInnerHTML: { __html: Ee } }, z, { role: oe ? "img" : void 0, "aria-hidden": !oe }));
        }
        const k = x().div`
  display: inline-flex;

  & > svg {
    width: 100%;
    height: 100%;
  }

  ${I.space};
  ${I.layout};
`;
      }, 685: (c, d, p) => {
        p.d(d, { Illustration: () => D, IllustrationBase: () => k });
        var y = p(689), S = p.n(y), w = p(518), x = p.n(w), _ = p(167), O = p.n(_), I = p(834), j = function(L, $) {
          var E = {};
          for (var z in L)
            Object.prototype.hasOwnProperty.call(L, z) && $.indexOf(z) < 0 && (E[z] = L[z]);
          if (L != null && typeof Object.getOwnPropertySymbols == "function") {
            var oe = 0;
            for (z = Object.getOwnPropertySymbols(L); oe < z.length; oe++)
              $.indexOf(z[oe]) < 0 && Object.prototype.propertyIsEnumerable.call(L, z[oe]) && (E[z[oe]] = L[z[oe]]);
          }
          return E;
        };
        function D(L) {
          var { name: $, className: E = "" } = L, z = j(L, ["name", "className"]);
          const oe = !!(z.title || z["aria-label"] || z["aria-labelledby"]), [Ee, ue] = (0, y.useState)(""), Oe = (0, y.useMemo)(() => {
            var K, J;
            return !((J = (K = window == null ? void 0 : window.env) === null || K === void 0 ? void 0 : K.ASSETS) === null || J === void 0) && J.includes("assets-t") ? "https://assets-t.storebrand.no/illustrations/" : "https://assets.storebrand.no/illustrations/";
          }, []), Ae = `illustration illustration-${$} ${E}`;
          return (0, y.useEffect)(() => {
            const K = O().CancelToken.source(), { href: J } = new URL(`${$}.svg`, Oe);
            return O().get(J, { cancelToken: K.token }).then((Z) => ue(Z.data)).catch((Z) => {
              O().isCancel(Z) || ue(`Can't find an icon with name ${$}!`);
            }), () => K.cancel("Canceling in cleanup");
          }, [$, Oe]), S().createElement(k, Object.assign({ className: Ae, dangerouslySetInnerHTML: { __html: Ee } }, z, { role: oe ? "img" : void 0, "aria-hidden": !oe }));
        }
        const k = x().div`
  display: inline-flex;

  & > svg {
    width: 100%;
    height: 100%;
  }

  ${I.space};
  ${I.layout};
`;
      }, 335: (c, d, p) => {
        p.d(d, { SystemIcon: () => _ });
        var y = p(689), S = p.n(y), w = p(24), x = function(O, I) {
          var j = {};
          for (var D in O)
            Object.prototype.hasOwnProperty.call(O, D) && I.indexOf(D) < 0 && (j[D] = O[D]);
          if (O != null && typeof Object.getOwnPropertySymbols == "function") {
            var k = 0;
            for (D = Object.getOwnPropertySymbols(O); k < D.length; k++)
              I.indexOf(D[k]) < 0 && Object.prototype.propertyIsEnumerable.call(O, D[k]) && (j[D[k]] = O[D[k]]);
          }
          return j;
        };
        function _(O) {
          var { name: I, children: j, color: D, size: k = 24 } = O, L = x(O, ["name", "children", "color", "size"]);
          const $ = !!(L.title || L["aria-label"] || L["aria-labelledby"]);
          return S().createElement(w.SystemIconBase, Object.assign({ color: D, size: k }, L, { role: $ ? "img" : void 0, "aria-hidden": !$ }), I || j);
        }
      }, 24: (c, d, p) => {
        p.d(d, { SystemIconBase: () => x });
        var y = p(518), S = p.n(y), w = p(834);
        const x = S().i`
  line-height: inherit;
  font-size: inherit;
  color: inherit;
  flex-shrink: 0;
  white-space: nowrap;

  ${w.space}

  ${({ color: _ }) => _ && y.css`
    color: var(--color-${String(_)});
  `}

  ${({ size: _ }) => y.css`
    width: ${_}px;
    font-size: ${_}px;
    line-height: ${_}px;
  `}
`;
      }, 167: (c) => {
        c.exports = ms();
      }, 689: (c) => {
        c.exports = ke;
      }, 518: (c) => {
        c.exports = Qr;
      }, 834: (c) => {
        c.exports = no;
      } }, a = {};
      function i(c) {
        var d = a[c];
        if (d !== void 0)
          return d.exports;
        var p = a[c] = { exports: {} };
        return t[c](p, p.exports, i), p.exports;
      }
      i.n = (c) => {
        var d = c && c.__esModule ? () => c.default : () => c;
        return i.d(d, { a: d }), d;
      }, i.d = (c, d) => {
        for (var p in d)
          i.o(d, p) && !i.o(c, p) && Object.defineProperty(c, p, { enumerable: !0, get: d[p] });
      }, i.o = (c, d) => Object.prototype.hasOwnProperty.call(c, d), i.r = (c) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(c, "__esModule", { value: !0 });
      };
      var f = {};
      return (() => {
        i.r(f), i.d(f, { Icon: () => c.Icon, IconBase: () => c.IconBase, Illustration: () => d.Illustration, IllustrationBase: () => d.IllustrationBase, SystemIcon: () => p.SystemIcon });
        var c = i(380), d = i(685), p = i(335);
      })(), f;
    })());
  }(jr)), jr.exports;
}
(function(r, o) {
  (function(t, a) {
    r.exports = a();
  })(self, () => (() => {
    var t = { 159: (c, d, p) => {
      p.d(d, { Contained: () => _, Icon: () => j, Outlined: () => O, Text: () => I });
      const y = Qr;
      var S = p.n(y);
      const w = no, x = S().button.attrs({ className: "button" })`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;

  height: 40px;
  padding: 8px 24px;
  border-radius: 2px;
  border: none;
  box-sizing: border-box;

  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  cursor: pointer;
  transition-property: border, background-color, color;
  transition-duration: .2s;
  -webkit-font-smoothing: antialiased;

  &:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
    outline-offset: none;
  }

  &:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  &::after {
    content: '';

    position: absolute;

    top: -4px;
    bottom: -4px;
    left: 0;
    right:0;
  }

  & > i {
    text-align: left;
    white-space: nowrap;
  }

  & > .icon-left {
    margin-right: 8px;
  }


  & > .icon-right {
    margin-left: 8px;
  }

  ${w.space}
`, _ = S()(x).attrs({ className: "button" })`
  background: var(--color-primary);
  color: var(--color-on-primary);

  &:hover, &:focus {
    color: var(--color-on-primary);
    background: var(--color-primary-variant);
  }

  &:active {
    background: var(--color-primary-pressed);
  }

  &[aria-disabled=true] {
    background: var(--color-disabled-variant);
    color: var(--color-disabled);
    cursor: not-allowed;
  }
`, O = S()(x)`
  color: var(--color-primary);
  background: rgba(0, 0, 0, 0);
  border: 1px solid var(--color-primary);

  padding: 7px 23px;

  &:hover, &:focus {
    background: var(--color-overlay-hover-darken);
  }

  &:active {
    color: var(--color-primary-pressed);
    border: 1px solid var(--color-primary-pressed);
  }

  &[aria-disabled=true] {
    border: 1px solid var(--color-disabled-variant);

    background: rgba(0, 0, 0, 0);
    color: var(--color-disabled);
    cursor: not-allowed;
  }

  &::after {
    content: '';

    position: absolute;

    top: -5px;
    bottom: -5px;
    left: 0;
    right:0;
  }
`, I = S()(x)`
  color: var(--color-primary);
  background: rgba(0, 0, 0, 0);

  &:hover, &:active, &:focus  {
    background: var(--color-overlay-hover-darken);
    color: var(--color-primary-variant);
  }

  &[aria-disabled=true] {
    background: rgba(0, 0, 0, 0);
    color: var(--color-disabled);
    cursor: not-allowed;
  }
`, j = S().button.attrs({ className: "button" })`
  position: relative;
  display: inline-flex;

  padding: 0;

  font-size: 16px;
  line-height: 16px;
  color: var(--color-primary);

  border: none;
  /* border-radius: 50%; */
  background-color: transparent;

  transition-property: color;
  transition-duration: .2s;

  text-decoration: none;

  cursor: pointer;

  &:hover > i {
    box-shadow:
      inset 0 0 0 8px var(--color-overlay-hover-darken),
      0 0 0 8px var(--color-overlay-hover-darken);
  }

  &:focus {
    outline: var(--outline);
    outline-offset: 16px;
  }
  &:focus:not(:focus-visible) {
    outline: 0;
  }
  &:focus-visible {
    outline: var(--outline);
    outline-offset: 16px;
  }

  & > i {
    margin: 0;
    border-radius: 50%;
    white-space: nowrap;
    transition-property: box-shadow;
    transition-duration: .2s;
  }
  
  ${({ size: D = 16 }) => D && y.css`
    & > i {
      font-size: ${D}px;
      line-height: ${D}px ;
    }
  `};

  &::after {
    content: '';

    position: absolute;

    top: -16px;
    bottom: -16px;
    left: -16px;
    right: -16px;
  }

  &[aria-disabled=true] {
    color: var(--color-disabled);

    &:hover  > i {
      box-shadow: none;
    }

    cursor: not-allowed;
  }

  ${({ color: D }) => D && y.css`
    & > i {
      color: var(--color-${D}) !important;
    }
  `}

  ${w.space}
`;
    } }, a = {};
    function i(c) {
      var d = a[c];
      if (d !== void 0)
        return d.exports;
      var p = a[c] = { exports: {} };
      return t[c](p, p.exports, i), p.exports;
    }
    i.n = (c) => {
      var d = c && c.__esModule ? () => c.default : () => c;
      return i.d(d, { a: d }), d;
    }, i.d = (c, d) => {
      for (var p in d)
        i.o(d, p) && !i.o(c, p) && Object.defineProperty(c, p, { enumerable: !0, get: d[p] });
    }, i.o = (c, d) => Object.prototype.hasOwnProperty.call(c, d), i.r = (c) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(c, "__esModule", { value: !0 });
    };
    var f = {};
    return (() => {
      i.r(f), i.d(f, { Button: () => x, default: () => _ });
      const c = ke;
      var d = i.n(c);
      const p = hs();
      var y = i.n(p);
      const S = gs();
      var w = i(159);
      const x = (0, c.forwardRef)((O, I) => {
        var { disabled: j, variant: D = "contained", loading: k = !1, iconLeft: L = "", iconRight: $ = "", onClick: E, children: z, size: oe = 16, color: Ee, as: ue = "button", type: Oe = "button" } = O, Ae = function(Z, ye) {
          var Ie = {};
          for (var he in Z)
            Object.prototype.hasOwnProperty.call(Z, he) && ye.indexOf(he) < 0 && (Ie[he] = Z[he]);
          if (Z != null && typeof Object.getOwnPropertySymbols == "function") {
            var ve = 0;
            for (he = Object.getOwnPropertySymbols(Z); ve < he.length; ve++)
              ye.indexOf(he[ve]) < 0 && Object.prototype.propertyIsEnumerable.call(Z, he[ve]) && (Ie[he[ve]] = Z[he[ve]]);
          }
          return Ie;
        }(O, ["disabled", "variant", "loading", "iconLeft", "iconRight", "onClick", "children", "size", "color", "as", "type"]);
        const K = D === "icon", J = (0, c.useMemo)(() => {
          switch (D) {
            case "contained":
            default:
              return w.Contained;
            case "outlined":
              return w.Outlined;
            case "text":
              return w.Text;
            case "icon":
              return w.Icon;
          }
        }, [D]);
        return d().createElement(J, Object.assign({ as: ue, ref: I, variant: D, "aria-disabled": j, onClick: j || k ? (Z) => Z.preventDefault() : E, size: oe, color: Ee, type: ue === "button" ? Oe : void 0 }, Ae), K ? null : k && d().createElement(y(), { size: "small", color: D === "contained" ? "on-primary" : "primary" }), !k && d().createElement(d().Fragment, null, L && d().createElement(S.SystemIcon, { className: "icon-left", name: L, size: K ? oe : 16, "aria-hidden": !0 }), !K && d().createElement("span", null, z), $ && d().createElement(S.SystemIcon, { className: "icon-right", name: $, size: K ? oe : 16, "aria-hidden": !0 })));
      }), _ = x;
    })(), f;
  })());
})($n);
var ys = $n.exports;
const vs = /* @__PURE__ */ ur(ys);
/*! js-cookie v3.0.5 | MIT */
function ar(r) {
  for (var o = 1; o < arguments.length; o++) {
    var t = arguments[o];
    for (var a in t)
      r[a] = t[a];
  }
  return r;
}
var bs = {
  read: function(r) {
    return r[0] === '"' && (r = r.slice(1, -1)), r.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(r) {
    return encodeURIComponent(r).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Vr(r, o) {
  function t(i, f, c) {
    if (!(typeof document > "u")) {
      c = ar({}, o, c), typeof c.expires == "number" && (c.expires = new Date(Date.now() + c.expires * 864e5)), c.expires && (c.expires = c.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var d = "";
      for (var p in c)
        c[p] && (d += "; " + p, c[p] !== !0 && (d += "=" + c[p].split(";")[0]));
      return document.cookie = i + "=" + r.write(f, i) + d;
    }
  }
  function a(i) {
    if (!(typeof document > "u" || arguments.length && !i)) {
      for (var f = document.cookie ? document.cookie.split("; ") : [], c = {}, d = 0; d < f.length; d++) {
        var p = f[d].split("="), y = p.slice(1).join("=");
        try {
          var S = decodeURIComponent(p[0]);
          if (c[S] = r.read(y, S), i === S)
            break;
        } catch {
        }
      }
      return i ? c[i] : c;
    }
  }
  return Object.create(
    {
      set: t,
      get: a,
      remove: function(i, f) {
        t(
          i,
          "",
          ar({}, f, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return Vr(this.converter, ar({}, this.attributes, i));
      },
      withConverter: function(i) {
        return Vr(ar({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(o) },
      converter: { value: Object.freeze(r) }
    }
  );
}
var Pn = Vr(bs, { path: "/" });
const kn = "features", Ss = ({ appName: r, version: o }) => {
  const t = () => {
    Pn.remove(kn), window.location.reload();
  }, a = Pn.get(kn);
  return /* @__PURE__ */ ut.jsx("div", { className: "environment-info-banner environment-info-test-branch-banner", children: a ? /* @__PURE__ */ ut.jsxs("span", { children: [
    `You are testing feature branch: ${Es(
      r,
      a
    )} - close to return to test`,
    /* @__PURE__ */ ut.jsx(
      vs,
      {
        variant: "text",
        iconRight: "close",
        onClick: t,
        color: "on-surface"
      }
    )
  ] }) : /* @__PURE__ */ ut.jsx(ws, { version: o }) });
}, Nn = "Unknown version", ws = ({
  version: r
}) => {
  const [o, t] = jn(
    void 0
  ), a = vo(
    async (i) => {
      try {
        const f = await fetch("./artifactInfo.json");
        if (f) {
          const c = await f.json();
          t(i === "gitSha-short" ? c.gitShaShort : i === "gitSha-long" ? c.gitSha : i);
        }
      } catch {
        t(Nn);
      }
    },
    []
  );
  return In(() => {
    r === "gitSha-short" || r === "gitSha-long" ? a(r) : t(r);
  }, [a, r]), /* @__PURE__ */ ut.jsxs("span", { children: [
    "TEST: ",
    o ?? Nn
  ] });
}, Es = (r, o) => {
  const a = new RegExp(`^${r}:(.+)$`).exec(o);
  return a && a.length > 1 ? a[1] : o;
};
const Rs = () => Ro() ? "test" : Eo() ? "development" : "production", Cs = ({
  appName: r,
  version: o = "gitSha-short"
}) => {
  const t = Rs();
  return t === "production" ? null : t === "development" ? /* @__PURE__ */ ut.jsx(xo, {}) : /* @__PURE__ */ ut.jsx(Ss, { appName: r, version: o });
};
export {
  Cs as EnvironmentInfo
};
